export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * DateTime
   *
   * GraphQL DateTime-Type for Dates
   */
  DateTime: { input: string | Date; output: string | Date; }
  /**
   * ObjectID
   *
   * GraphQL ID-Type for MongoDB ID
   */
  ObjectID: { input: string; output: string; }
  /**
   * Upload
   *
   * GraphQL Upload-Type for File Uploads
   */
  Upload: { input: File; output: File; }
};

/** Possible outcomes when attempting to activate a User. */
export type ActivateUserResponse = ActivateUserSuccessfulResponse | ErrorResponse;

/** Response payload after successfully activating a User. */
export type ActivateUserSuccessfulResponse = {
  __typename: 'ActivateUserSuccessfulResponse';
  /** The ID of the activated user. */
  activatedId: Scalars['ObjectID']['output'];
  /** Indicates if the activation was successful. Always true on success. */
  success: Scalars['Boolean']['output'];
};

/** A module definition for an assessment. */
export type AssessmentModuleDefinition = BaseModuleDefinition & VariantSpecifics & {
  __typename: 'AssessmentModuleDefinition';
  category: ModuleCategory;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupingKey: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  identifier: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  levelOrVariant?: Maybe<Scalars['String']['output']>;
  maxDurationMinutes?: Maybe<Scalars['Int']['output']>;
  minDurationMinutes?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  subCategory?: Maybe<ModuleSubCategory>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a completed assessment result linked to an assessment run. */
export type AssessmentResult = {
  __typename: 'AssessmentResult';
  assessmentRun?: Maybe<AssessmentRun>;
  assessmentRunId?: Maybe<Scalars['ObjectID']['output']>;
  company: Company;
  companyId: Scalars['ObjectID']['output'];
  completedAt: Scalars['DateTime']['output'];
  courseInstance?: Maybe<CourseInstance>;
  courseInstanceId?: Maybe<Scalars['ObjectID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ObjectID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  moduleInstance?: Maybe<ModuleInstance>;
  moduleInstanceId?: Maybe<Scalars['ObjectID']['output']>;
  result: AssessmentResultData;
  source: ResultSource;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['ObjectID']['output'];
  updatedByUser?: Maybe<User>;
  user?: Maybe<User>;
  userId: Scalars['ObjectID']['output'];
};

/** Union type for assessment result data. */
export type AssessmentResultData = CardioRespResult | InbodyCompositionResult | IndividualMotivationResult | Ml360Result | SartResult | SelfDeterminationResult | SpatialPlanningResult | StrengthResult | TeamResilienceResult | TrainersNotesResult | VisualReactionResult;

/** Input type for filtering assessment results. */
export type AssessmentResultFilterRule = {
  /** The assessment run IDs to filter results by. */
  assessmentRunIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** The company IDs to filter results by. */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** The course instance IDs to filter results by. */
  courseInstanceIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** The group ids to filter results by. */
  groupIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Whether to include buddy results in the filter. */
  includeBuddyResults?: InputMaybe<Scalars['Boolean']['input']>;
  /** The module instance IDs to filter results by. */
  moduleInstanceIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** The assessment result types to filter results by. */
  resultTypes?: InputMaybe<Array<AssessmentResultType>>;
  /** The search text to filter results by. */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** The subgroup ids to filter results by. */
  subgroupIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** The user IDs to filter results by. */
  userIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

/**
 * Fields available for sorting AssessmentResults.
 * Each field corresponds to a property in the AssessmentResult entity.
 */
export enum AssessmentResultSortingField {
  AssessmentRunName = 'AssessmentRunName',
  CompletionDate = 'CompletionDate',
  EndDate = 'EndDate',
  GroupName = 'GroupName',
  ModuleName = 'ModuleName',
  Programme = 'Programme',
  StartDate = 'StartDate',
  SubGroupName = 'SubGroupName',
  TraineeName = 'TraineeName'
}

/** Input type for sorting Assessment Result. */
export type AssessmentResultSortingRule = {
  /** The field by which to sort the Assessment Result. */
  field: AssessmentResultSortingField;
  /** The order in which to sort the Assessment Result. */
  order: SortingOrder;
};

/** Enum for the type of assessment result. */
export enum AssessmentResultType {
  CardioResp = 'CardioResp',
  InbodyComposition = 'InbodyComposition',
  IndividualMotivation = 'IndividualMotivation',
  Ml360Buddy = 'ML360Buddy',
  Ml360Self = 'ML360Self',
  Ml360Trainer = 'ML360Trainer',
  Sart = 'SART',
  SelfDetermination = 'SelfDetermination',
  SpatialPlanning = 'SpatialPlanning',
  Strength = 'Strength',
  TeamResilience = 'TeamResilience',
  TrainersNotes = 'TrainersNotes',
  VisualRxn = 'VisualRxn'
}

/** Represents the details of an assessment run. */
export type AssessmentRun = {
  __typename: 'AssessmentRun';
  companyId: Scalars['ObjectID']['output'];
  completionDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  endDate: Scalars['DateTime']['output'];
  group: Group;
  groupId: Scalars['ObjectID']['output'];
  id: Scalars['ObjectID']['output'];
  moduleSnapshots: Array<ModuleSnapshot>;
  name: Scalars['String']['output'];
  program?: Maybe<Program>;
  programId: Scalars['ObjectID']['output'];
  startDate: Scalars['DateTime']['output'];
  status: AssessmentRunStatus;
  subGroupIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  subGroups?: Maybe<Array<Subgroup>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

/** Defines AssessmentRunCreationInput for creating a new assessment run in the system. */
export type AssessmentRunCreationInput = {
  endDate: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

/** Input for filtering AssessmentRuns. */
export type AssessmentRunFilteringRule = {
  assessmentRunIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  hasCompletionDate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['ObjectID']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Fields available for sorting AssessmentRuns.
 * Each field corresponds to a property in the AssessmentRun entity.
 */
export enum AssessmentRunSortingField {
  CompletionDate = 'CompletionDate',
  CreatedAt = 'CreatedAt',
  EndDate = 'EndDate',
  Name = 'Name',
  ProgramName = 'ProgramName',
  StartDate = 'StartDate'
}

/** Input type for sorting AssessmentRun. */
export type AssessmentRunSortingRule = {
  field: AssessmentRunSortingField;
  order: SortingOrder;
};

/**
 * Defines the current status of an assessment run.
 * Used to track the lifecycle state of assessment runs.
 */
export enum AssessmentRunStatus {
  /** Assessment run has been Ended. */
  Ended = 'Ended',
  /** Assessment run is currently active and in progress. */
  InProgress = 'InProgress',
  /** Assessment run has been created but not yet started. */
  NotStarted = 'NotStarted'
}

/** Defines AssessmentRunUpdateInput for updating an existing assessment run in the system. */
export type AssessmentRunUpdateInput = {
  endDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  name: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

/** Represents a group assignment with associated subgroups and buddies. */
export type AssignedGroup = {
  __typename: 'AssignedGroup';
  buddies?: Maybe<Array<TenantUser>>;
  buddyIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  group?: Maybe<Group>;
  groupId: Scalars['ObjectID']['output'];
  subGroupIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  subGroups?: Maybe<Array<Subgroup>>;
};

/** Input type for group assignment with associated subgroups and buddies. */
export type AssignedGroupInput = {
  buddyIds: Array<Scalars['ObjectID']['input']>;
  groupId: Scalars['ObjectID']['input'];
  subGroupIds: Array<Scalars['ObjectID']['input']>;
};

/** Enum for the award result. */
export enum AwardResult {
  Bronze = 'Bronze',
  Gold = 'Gold',
  Silver = 'Silver'
}

/** Interface representing common fields for all courses. */
export type BaseCourse = {
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<BaseUser>;
  description: Scalars['String']['output'];
  duration: Duration;
  executionSequence: Array<Maybe<ExecutionSequence>>;
  id: Scalars['ObjectID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<BaseUser>;
};

/** Base interface for all module definitions. */
export type BaseModuleDefinition = {
  /** Timestamp when the definition was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Short description of the module's purpose. */
  description?: Maybe<Scalars['String']['output']>;
  /** Key linking related module variants (e.g., 'sart'). Used for UI grouping. */
  groupingKey: Scalars['String']['output'];
  /** Unique MongoDB identifier. */
  id: Scalars['ObjectID']['output'];
  /** Unique identifier for this specific module definition (e.g., 'sart-beginner'). */
  identifier: Scalars['String']['output'];
  /** Availability flag. */
  isActive: Scalars['Boolean']['output'];
  /** Display name (e.g., 'SART - Beginner'). */
  name: Scalars['String']['output'];
  /** Timestamp when the definition was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Defines common fields for all module instance configurations. */
export type BaseModuleInstanceConfiguration = {
  demoVideo?: Maybe<UploadedFile>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/** Interface representing common fields for all users. */
export type BaseUser = {
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<BaseUser>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  has2FASetup: Scalars['Boolean']['output'];
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  isSuperAdmin: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  otpAuthenticator?: Maybe<OtpAuthenticator>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<BaseUser>;
};

/**
 * Basic Authentication Require 2FA Setup Response
 *
 * This is the response returned when a user needs to set up 2FA before they can continue.
 */
export type BasicAuthenticationRequire2FaSetupResponse = {
  __typename: 'BasicAuthenticationRequire2FASetupResponse';
  token: Scalars['String']['output'];
};

/**
 * Basic Authentication Require Otp Response
 *
 * This is the response returned from require otp of basic authentication request.
 */
export type BasicAuthenticationRequireOtpResponse = {
  __typename: 'BasicAuthenticationRequireOtpResponse';
  token: Scalars['String']['output'];
};

/**
 * Basic Authentication Reset Password Response
 *
 * This is the response returned from reset password of basic authentication request.
 */
export type BasicAuthenticationResetPasswordResponse = {
  __typename: 'BasicAuthenticationResetPasswordResponse';
  token: Scalars['String']['output'];
};

/**
 * Basic Authentication Response
 *
 * The response may be of two types:
 * - BasicAuthenticationSuccessfulResponse : in case of success
 * - BasicAuthenticationRequireOtpResponse : in case of success
 * - BasicAuthenticationRequire2FASetupResponse : when 2FA setup is required
 * - ErrorResponse : in case of error
 */
export type BasicAuthenticationResponse = BasicAuthenticationRequire2FaSetupResponse | BasicAuthenticationRequireOtpResponse | BasicAuthenticationResetPasswordResponse | BasicAuthenticationSuccessfulResponse | ErrorResponse;

/**
 * Basic Authentication Successful Response
 *
 * This is the response returned from a successful basic authentication request.
 */
export type BasicAuthenticationSuccessfulResponse = {
  __typename: 'BasicAuthenticationSuccessfulResponse';
  token: Scalars['String']['output'];
  user: User;
};

/** Specific configuration for an BMP module instance. */
export type BmpConfiguration = BaseModuleInstanceConfiguration & PhysicalBaseConfiguration & {
  __typename: 'BmpConfiguration';
  allowBulkImport: Scalars['Boolean']['output'];
  allowManualEntry: Scalars['Boolean']['output'];
  demoVideo?: Maybe<UploadedFile>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents the result for BMP. */
export type BmpResult = {
  __typename: 'BmpResult';
  percentage?: Maybe<Scalars['Float']['output']>;
};

/**
 * Input representing the BMP assessment result details.
 * Fields are optional to allow partial submissions based on available measurements.
 */
export type BmpResultInput = {
  /** BMP percentage */
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

/** Broadcast type */
export type Broadcast = UserSessionBroadcast;

/** Possible outcomes when attempting to cancel an invitation. */
export type CancelInvitationPayload = CancelInvitationSuccessfulResponse | ErrorResponse;

/** Response payload after successfully cancelling an invitation. */
export type CancelInvitationSuccessfulResponse = {
  __typename: 'CancelInvitationSuccessfulResponse';
  result: Scalars['Boolean']['output'];
};

/** Specific configuration for an CardioResp module instance. */
export type CardioRespConfiguration = BaseModuleInstanceConfiguration & PhysicalBaseConfiguration & {
  __typename: 'CardioRespConfiguration';
  allowBulkImport: Scalars['Boolean']['output'];
  allowManualEntry: Scalars['Boolean']['output'];
  demoVideo?: Maybe<UploadedFile>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents the result for CardioResp. */
export type CardioRespResult = {
  __typename: 'CardioRespResult';
  exerciseHR?: Maybe<Scalars['Int']['output']>;
  hrvMs?: Maybe<Scalars['Float']['output']>;
  restingHR?: Maybe<Scalars['Int']['output']>;
  vo2Max?: Maybe<Scalars['Float']['output']>;
};

/**
 * Input representing the Cardio Respiratory assessment result details.
 * Fields are optional to allow partial submissions based on available measurements.
 */
export type CardioRespResultInput = {
  exerciseHR?: InputMaybe<Scalars['Int']['input']>;
  hrvMs?: InputMaybe<Scalars['Float']['input']>;
  restingHR?: InputMaybe<Scalars['Int']['input']>;
  vo2Max?: InputMaybe<Scalars['Float']['input']>;
};

/** Category configuration for Visual Reaction assessment. */
export type CategoryDetail = {
  __typename: 'CategoryDetail';
  /** Image category. */
  category: ImageCategory;
  /** Percentage distribution for this category (0-100). */
  percentage: Scalars['Float']['output'];
};

/** Input type for category images configuration. */
export type CategoryDetailInput = {
  /** Image category. */
  category: ImageCategory;
  /** Percentage distribution for this category (0-100). */
  percentage: Scalars['Float']['input'];
};

/**
 * Change Email Response
 *
 * The response may be of two types:
 * - ChangeEmailSuccessfulResponse : in case of success
 * - ErrorResponse : in case of error
 */
export type ChangeEmailResponse = ChangeEmailSuccessfulResponse | ErrorResponse;

/**
 * Change Email Successful Response
 *
 * This is the response returned from a successful change email request.
 */
export type ChangeEmailSuccessfulResponse = {
  __typename: 'ChangeEmailSuccessfulResponse';
  result: Scalars['Boolean']['output'];
};

/**
 * Change Password Response
 *
 * The response may be of two types:
 * - ChangePasswordResponseSuccessfulResponse : in case of success
 * - ErrorResponse : in case of error
 */
export type ChangePasswordResponse = ChangePasswordSuccessfulResponse | ErrorResponse;

/**
 * Change Password Successful Response
 *
 * This is the response returned from a successful change password request.
 */
export type ChangePasswordSuccessfulResponse = {
  __typename: 'ChangePasswordSuccessfulResponse';
  result: Scalars['Boolean']['output'];
};

/** Represents a tenant Company within the system. */
export type Company = {
  __typename: 'Company';
  /** Contact information for the company */
  contactInfo: CompanyContactInfo;
  /** Timestamp of creation */
  createdAt: Scalars['DateTime']['output'];
  /** Enabled module identifiers for the company */
  enabledModules: Array<Scalars['String']['output']>;
  /** Unique identifier (ObjectId) */
  id: Scalars['ObjectID']['output'];
  /** Invitations for the company */
  invitations: Array<Maybe<CompanyInvitation>>;
  /** Company status */
  isActive: Scalars['Boolean']['output'];
  /** Full name of the company */
  name: Scalars['String']['output'];
  /** Role customization settings for the company. */
  roleSettings: Array<CompanyRoleSetting>;
  /** General settings for the company */
  settings: CompanyGeneralSettings;
  /** Optional short name or abbreviation */
  shortName?: Maybe<Scalars['String']['output']>;
  /** Subscription details for the company */
  subscriptions: Array<CompanySubscription>;
  /** Timestamp of last update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Contact information for a company */
export type CompanyContactInfo = {
  __typename: 'CompanyContactInfo';
  /** Company address (street, city, postal code, country) */
  address?: Maybe<Scalars['String']['output']>;
  /** Email for primary contact */
  email: Scalars['String']['output'];
  /** Main point of contact name */
  name: Scalars['String']['output'];
  /** Phone number for primary contact */
  phone?: Maybe<Scalars['String']['output']>;
};

/** Input for company contact information */
export type CompanyContactInfoInput = {
  /** Company address (street, city, postal code, country) */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Email for primary contact */
  email: Scalars['String']['input'];
  /** Main point of contact name */
  name: Scalars['String']['input'];
  /** Phone number for primary contact */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for filtering Companies. */
export type CompanyFilteringRule = {
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by active status. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by company name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter across multiple relevant fields (name, shortName) using a single search term. */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Filter by company short name */
  shortName?: InputMaybe<Scalars['String']['input']>;
};

/** General settings for a company */
export type CompanyGeneralSettings = {
  __typename: 'CompanyGeneralSettings';
  /** Data retention period */
  dataRetentionPeriod: Scalars['Int']['output'];
  /** Whether to enforce OTP 2FA for the company */
  enforceOtp2FA: Scalars['Boolean']['output'];
  /** Notification settings */
  notifications?: Maybe<CompanyNotificationSettings>;
};

/** Input for company general settings */
export type CompanyGeneralSettingsInput = {
  /** Data retention period */
  dataRetentionPeriod: Scalars['Int']['input'];
  /** Whether to enforce OTP 2FA for the company */
  enforceOtp2FA: Scalars['Boolean']['input'];
  /** Notification settings */
  notifications: CompanyNotificationSettingsInput;
};

/** Represents an invitation for a user to join a company. */
export type CompanyInvitation = {
  __typename: 'CompanyInvitation';
  assignedGroups?: Maybe<Array<AssignedGroup>>;
  company?: Maybe<Company>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ObjectID']['output'];
  invitedAt: Scalars['DateTime']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  requestingUser?: Maybe<User>;
  role?: Maybe<UserRole>;
};

/** Input type for filtering Company Invitations. */
export type CompanyInvitationFilteringRule = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

/** Fields available for sorting Company Invitations. */
export enum CompanyInvitationSortingField {
  CompanyName = 'CompanyName',
  Email = 'Email',
  InvitedAt = 'InvitedAt',
  Role = 'Role'
}

/** Input type for sorting Company Invitations. */
export type CompanyInvitationSortingRule = {
  field: CompanyInvitationSortingField;
  order: SortingOrder;
};

/** Notification settings for a company */
export type CompanyNotificationSettings = {
  __typename: 'CompanyNotificationSettings';
  /** Custom sender name for emails */
  emailSenderName?: Maybe<Scalars['String']['output']>;
  /** Custom text for Report Availability notification email */
  reportAvailabilityEmailText?: Maybe<Scalars['String']['output']>;
  /** Whether to send notifications when reports are available */
  reportAvailabilityNotification: Scalars['Boolean']['output'];
  /** How users register - via invitation or self-registration */
  userRegistrationMode: UserRegistrationMode;
  /** Custom text for Welcome email */
  welcomeEmailText?: Maybe<Scalars['String']['output']>;
};

/** Input for company notification settings */
export type CompanyNotificationSettingsInput = {
  /** Custom sender name for emails */
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  /** Custom text for Report Availability notification email */
  reportAvailabilityEmailText?: InputMaybe<Scalars['String']['input']>;
  /** Whether to send notifications when reports are available */
  reportAvailabilityNotification: Scalars['Boolean']['input'];
  /** How users register - via invitation or self-registration */
  userRegistrationMode: UserRegistrationMode;
  /** Custom text for Welcome email */
  welcomeEmailText?: InputMaybe<Scalars['String']['input']>;
};

/** Configuration for a specific role within a company. */
export type CompanyRoleSetting = {
  __typename: 'CompanyRoleSetting';
  /** The custom name assigned to this role by the company. */
  customName: Scalars['String']['output'];
  /** Indicates if this role is enabled for the company. */
  isEnabled: Scalars['Boolean']['output'];
  /** The base system role this setting applies to. Refer to UserRole enum. */
  role: UserRole;
};

/** Input for configuring a specific role within a company. */
export type CompanyRoleSettingInput = {
  /** The custom name for this role. */
  customName: Scalars['String']['input'];
  /** Whether this role should be enabled for the company. */
  isEnabled: Scalars['Boolean']['input'];
  /** The base system role to configure. Refer to UserRole enum. */
  role: UserRole;
};

/** Fields available for sorting Companies. */
export enum CompanySortingField {
  IsActive = 'IsActive',
  Licenses = 'Licenses',
  Name = 'Name',
  ShortName = 'ShortName',
  SubscriptionEndDate = 'SubscriptionEndDate',
  SubscriptionStartDate = 'SubscriptionStartDate'
}

/** Input type for sorting Companies. */
export type CompanySortingRule = {
  field: CompanySortingField;
  order: SortingOrder;
};

/** Subscription details for a company */
export type CompanySubscription = {
  __typename: 'CompanySubscription';
  /** Subscription duration in months */
  durationMonths: Scalars['Int']['output'];
  /** The actual date the subscription access ends, including free trial and extensions. */
  effectiveEndDate: Scalars['DateTime']['output'];
  /** The actual date the subscription access begins (usually the same as startDate). */
  effectiveStartDate: Scalars['DateTime']['output'];
  /** Date when platform access expires */
  endDate: Scalars['DateTime']['output'];
  /** Extension duration in days */
  extensionDays?: Maybe<Scalars['Int']['output']>;
  /** Free trial duration in days */
  freeTrialDays?: Maybe<Scalars['Int']['output']>;
  /** Total number of user accounts allowed */
  maxUserLicenses: Scalars['Int']['output'];
  /** Number of days before expiry to send notification */
  renewalReminderDays?: Maybe<Scalars['Int']['output']>;
  /** Date when platform access begins */
  startDate: Scalars['DateTime']['output'];
  /** Current number of user accounts created */
  usedLicenses: Scalars['Int']['output'];
};

/**
 * Confirm Email Response
 *
 * The response may be of two types:
 * - ConfirmEmailSuccessfulResponse : in case of success
 * - ErrorResponse : in case of error
 */
export type ConfirmEmailResponse = ConfirmEmailSuccessfulResponse | ErrorResponse;

/**
 * Confirm Email Successful Response
 *
 * This is the response returned from a successful confirm email request.
 */
export type ConfirmEmailSuccessfulResponse = {
  __typename: 'ConfirmEmailSuccessfulResponse';
  result: Scalars['Boolean']['output'];
};

/** Defines the union of course types */
export type Course = CourseInstance | CourseTemplate;

/** Represents a course instance */
export type CourseInstance = BaseCourse & {
  __typename: 'CourseInstance';
  /** Instance-specific fields */
  companyId: Scalars['ObjectID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<BaseUser>;
  description: Scalars['String']['output'];
  duration: Duration;
  executionSequence: Array<Maybe<ExecutionSequence>>;
  groups: Array<Group>;
  id: Scalars['ObjectID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isModifiedFromTemplate?: Maybe<Scalars['Boolean']['output']>;
  lifecycleState: CourseLifecycleState;
  name: Scalars['String']['output'];
  sourceTemplate?: Maybe<CourseTemplate>;
  sourceTemplateId?: Maybe<Scalars['ObjectID']['output']>;
  sourceTemplateVersion?: Maybe<Scalars['Int']['output']>;
  sourceType: SourceType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<BaseUser>;
};

/** Input type for filtering Course Instances. */
export type CourseInstanceFilteringRule = {
  /** Filter by course instance description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Filter by course instance name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter across multiple relevant fields (name, description) using a single search term. */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

/** Fields available for sorting Course Instances. */
export enum CourseInstanceSortingField {
  CreatedBy = 'CreatedBy',
  Groups = 'Groups',
  Name = 'Name',
  TotalMemberCount = 'TotalMemberCount',
  UpdatedAt = 'UpdatedAt'
}

/** Input type for sorting Course Instances. */
export type CourseInstanceSortingRule = {
  field: CourseInstanceSortingField;
  order: SortingOrder;
};

/** Defines the lifecycle state of a course */
export enum CourseLifecycleState {
  Active = 'Active',
  Completed = 'Completed',
  InProgress = 'InProgress'
}

/** Defines the Course Template type */
export type CourseTemplate = BaseCourse & {
  __typename: 'CourseTemplate';
  companies: Array<Company>;
  companyIds: Array<Maybe<Scalars['ObjectID']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<BaseUser>;
  description: Scalars['String']['output'];
  duration: Duration;
  executionSequence: Array<Maybe<ExecutionSequence>>;
  id: Scalars['ObjectID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Template-specific fields */
  sourceType: SourceType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<BaseUser>;
  version: Scalars['Int']['output'];
};

/** Input type for filtering Course Templates. */
export type CourseTemplateFilteringRule = {
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by course template description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Filter by course template name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter across multiple relevant fields (name, description) using a single search term. */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

/** Fields available for sorting Course Templates. */
export enum CourseTemplateSortingField {
  CreatedBy = 'CreatedBy',
  Name = 'Name',
  UpdatedAt = 'UpdatedAt'
}

/** Input type for sorting Course Templates. */
export type CourseTemplateSortingRule = {
  field: CourseTemplateSortingField;
  order: SortingOrder;
};

/** Input for creating a new Assessment Runs. */
export type CreateAssessmentRunsInput = {
  assessmentRuns: Array<AssessmentRunCreationInput>;
  groupId: Scalars['ObjectID']['input'];
  programId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to create a CreateAssessmentRuns. */
export type CreateAssessmentRunsPayload = CreateAssessmentRunsSuccessfulResponse | ErrorResponse;

/** Response payload after successfully creating a Assessment Runs. */
export type CreateAssessmentRunsSuccessfulResponse = {
  __typename: 'CreateAssessmentRunsSuccessfulResponse';
  /** The newly created Assessment Runs object. */
  result: Array<AssessmentRun>;
};

/** Input for creating a new Company. */
export type CreateCompanyInput = {
  /** Contact information for the company. */
  contactInfo: CompanyContactInfoInput;
  /** Enabled module identifiers for the company */
  enabledModules: Array<Scalars['String']['input']>;
  /** General settings for the company. */
  generalSettings: CompanyGeneralSettingsInput;
  /** Company status. */
  isActive: Scalars['Boolean']['input'];
  /** The full name for the new company. Must be unique. */
  name: Scalars['String']['input'];
  /** Optional: Role customization settings. If not provided, defaults will be applied. */
  roleSettings: Array<CompanyRoleSettingInput>;
  /** An optional short name or abbreviation. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Subscription details for the company. */
  subscription: NewCompanySubscriptionInput;
};

/** Possible outcomes when attempting to create a Company. */
export type CreateCompanyPayload = CreateCompanySuccessfulResponse | ErrorResponse;

/** Response payload after successfully creating a Company. */
export type CreateCompanySuccessfulResponse = {
  __typename: 'CreateCompanySuccessfulResponse';
  /** The newly created Company object. */
  result: Company;
};

/**
 * Input for creating a course instance from scratch
 * Requires execution sequence as it is not copied from the template
 */
export type CreateCourseInstanceCustomInput = {
  companyId: Scalars['ObjectID']['input'];
  description: Scalars['String']['input'];
  duration: DurationInput;
  executionSequence: Array<ExecutionSequenceInput>;
  name: Scalars['String']['input'];
};

/**
 * Input for creating a course instance from a template
 * Includes execution sequence to allow customization from the original template
 * (adding/removing modules or changing order)
 */
export type CreateCourseInstanceFromTemplateInput = {
  companyId: Scalars['ObjectID']['input'];
  description: Scalars['String']['input'];
  duration: DurationInput;
  executionSequence: Array<ExecutionSequenceInput>;
  name: Scalars['String']['input'];
  sourceTemplateId: Scalars['ObjectID']['input'];
  sourceTemplateVersion: Scalars['Int']['input'];
};

/** Possible outcomes when attempting to create a Course. */
export type CreateCourseInstancePayload = CreateCourseInstanceSuccessfulResponse | ErrorResponse;

/** Response payload after successfully creating a Course Instance. */
export type CreateCourseInstanceSuccessfulResponse = {
  __typename: 'CreateCourseInstanceSuccessfulResponse';
  /** The newly created Course Instance object. */
  result: CourseInstance;
};

/** Input for creating a course template */
export type CreateCourseTemplateInput = {
  companyIds: Array<Scalars['ObjectID']['input']>;
  description: Scalars['String']['input'];
  duration: DurationInput;
  executionSequence: Array<ExecutionSequenceInput>;
  isPublic: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

/** Possible outcomes when attempting to create a Course Template. */
export type CreateCourseTemplatePayload = CreateCourseTemplateSuccessfulResponse | ErrorResponse;

/** Response payload after successfully creating a Course Template. */
export type CreateCourseTemplateSuccessfulResponse = {
  __typename: 'CreateCourseTemplateSuccessfulResponse';
  /** The newly created Course Template object. */
  result: CourseTemplate;
};

/** Input for creating a new glossary term. */
export type CreateGlossaryInput = {
  definition: Scalars['String']['input'];
  term: Scalars['String']['input'];
};

/** Possible outcomes when attempting to create a Glossary. */
export type CreateGlossaryPayload = CreateGlossarySuccessfulResponse | ErrorResponse;

/** Create Glossary Successful Response */
export type CreateGlossarySuccessfulResponse = {
  __typename: 'CreateGlossarySuccessfulResponse';
  /** The newly created Glossary object. */
  result: Glossary;
};

/** Input for creating a new Group. */
export type CreateGroupInput = {
  /** Company identifier (ObjectId) this group belongs to. */
  companyId: Scalars['ObjectID']['input'];
  /** Description of the group. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** List of enrolled course IDs. */
  enrolledCourseIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** The name of the group. */
  name: Scalars['String']['input'];
};

/** Possible outcomes when attempting to create a Group. */
export type CreateGroupPayload = CreateGroupSuccessfulResponse | ErrorResponse;

/** Response payload after successfully creating a Group. */
export type CreateGroupSuccessfulResponse = {
  __typename: 'CreateGroupSuccessfulResponse';
  /** The newly created Group object. */
  result: Group;
};

/** Input type for creating a Module Instance. */
export type CreateModuleInstanceInput = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  configuration: ModuleInstanceConfigurationInput;
  description?: InputMaybe<Scalars['String']['input']>;
  moduleDefinitionIdentifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Possible outcomes when attempting to create a Module Instance. */
export type CreateModuleInstancePayload = CreateModuleInstanceSuccessfulResponse | ErrorResponse;

/** Response payload after successfully creating a Module Instance. */
export type CreateModuleInstanceSuccessfulResponse = {
  __typename: 'CreateModuleInstanceSuccessfulResponse';
  result: ModuleInstance;
};

/** Input for creating a Program. */
export type CreateProgramInput = {
  courseInstanceId: Scalars['ObjectID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  occurrence: ProgramOccurrence;
};

/** Possible outcomes when attempting to create a CreateProgram. */
export type CreateProgramPayload = CreateProgramSuccessfulResponse | ErrorResponse;

/** Response payload after successfully creating a Program. */
export type CreateProgramSuccessfulResponse = {
  __typename: 'CreateProgramSuccessfulResponse';
  /** The newly created Program object. */
  result: Program;
};

/** Create a subgroup within a group. */
export type CreateSubgroupInput = {
  /** Company identifier (ObjectId) this group belongs to. */
  companyId: Scalars['ObjectID']['input'];
  /** Description of the subgroup. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the subgroup. */
  name: Scalars['String']['input'];
  /** Group identifier (ObjectId) this subgroup belongs to. */
  parentGroupId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to create a Subgroup. */
export type CreateSubgroupPayload = CreateSubgroupSuccessfulResponse | ErrorResponse;

/** Response payload after successfully creating a Subgroup. */
export type CreateSubgroupSuccessfulResponse = {
  __typename: 'CreateSubgroupSuccessfulResponse';
  /** The newly created Subgroup object. */
  result: Subgroup;
};

/** Input to create a new User. */
export type CreateUserInput = {
  assignedGroups?: InputMaybe<Array<AssignedGroupInput>>;
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  height?: InputMaybe<Scalars['Int']['input']>;
  isSuperAdmin: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
};

/** Possible outcomes when attempting to create a User. */
export type CreateUserResponse = CreateUserSuccessfulResponse | ErrorResponse;

/** Response payload after successfully creating a User. */
export type CreateUserSuccessfulResponse = {
  __typename: 'CreateUserSuccessfulResponse';
  result: User;
};

/** Possible outcomes when attempting to deactivate a User. */
export type DeactivateUserResponse = DeactivateUserSuccessfulResponse | ErrorResponse;

/** Response payload after successfully deactivating a User. */
export type DeactivateUserSuccessfulResponse = {
  __typename: 'DeactivateUserSuccessfulResponse';
  /** The ID of the deactivated user. */
  deactivatedId: Scalars['ObjectID']['output'];
  /** Indicates if the deactivation was successful. Always true on success. */
  success: Scalars['Boolean']['output'];
};

/** Possible outcomes when attempting to delete an Assessment Result. */
export type DeleteAssessmentResultPayload = DeleteAssessmentResultSuccessfulResponse | ErrorResponse;

/** Response payload after successfully deleting an Assessment Result. */
export type DeleteAssessmentResultSuccessfulResponse = {
  __typename: 'DeleteAssessmentResultSuccessfulResponse';
  deletedId: Scalars['ObjectID']['output'];
  success: Scalars['Boolean']['output'];
};

/** Possible outcomes when attempting to delete assessment runs. */
export type DeleteAssessmentRunsPayload = DeleteAssessmentRunsSuccessfulResponse | ErrorResponse;

/** Response payload after successfully deleting Assessment Runs. */
export type DeleteAssessmentRunsSuccessfulResponse = {
  __typename: 'DeleteAssessmentRunsSuccessfulResponse';
  /** Indicates if the deletion was successful. Always true on success. */
  success: Scalars['Boolean']['output'];
};

/** Possible outcomes when attempting to delete a Company. */
export type DeleteCompanyPayload = DeleteCompanySuccessfulResponse | ErrorResponse;

/** Response payload after successfully deleting a Company. */
export type DeleteCompanySuccessfulResponse = {
  __typename: 'DeleteCompanySuccessfulResponse';
  /** The ID of the deleted company. */
  deletedId: Scalars['ObjectID']['output'];
  /** Indicates if the deletion was successful. Always true on success. */
  success: Scalars['Boolean']['output'];
};

/** Possible outcomes when attempting to delete a Course Instance. */
export type DeleteCourseInstancePayload = DeleteCourseInstanceSuccessfulResponse | ErrorResponse;

/** Response payload after successfully deleting a Course Instance. */
export type DeleteCourseInstanceSuccessfulResponse = {
  __typename: 'DeleteCourseInstanceSuccessfulResponse';
  /** The ID of the deleted course instance. */
  deletedId: Scalars['ObjectID']['output'];
  /** Indicates if the deletion was successful. Always true on success. */
  success: Scalars['Boolean']['output'];
};

/** Possible outcomes when attempting to delete a Course Template. */
export type DeleteCourseTemplatePayload = DeleteCourseTemplateSuccessfulResponse | ErrorResponse;

/** Possible outcomes when attempting to delete a Course Template series. */
export type DeleteCourseTemplateSeriesPayload = DeleteCourseTemplateSeriesSuccessfulResponse | ErrorResponse;

/** Response payload after successfully deleting a Course Template series. */
export type DeleteCourseTemplateSeriesSuccessfulResponse = {
  __typename: 'DeleteCourseTemplateSeriesSuccessfulResponse';
  /** The IDs of all deleted template versions. */
  deletedIds: Array<Scalars['ObjectID']['output']>;
  /** The number of template versions that were deleted. */
  deletedVersionsCount: Scalars['Int']['output'];
  /** Indicates if the deletion was successful. Always true on success. */
  success: Scalars['Boolean']['output'];
  /** The name of the deleted course template series. */
  templateName: Scalars['String']['output'];
};

/** Response payload after successfully deleting a Course Template. */
export type DeleteCourseTemplateSuccessfulResponse = {
  __typename: 'DeleteCourseTemplateSuccessfulResponse';
  /** The ID of the deleted course template. */
  deletedId: Scalars['ObjectID']['output'];
  /** Indicates if the deletion was successful. Always true on success. */
  success: Scalars['Boolean']['output'];
};

/** Possible outcomes when attempting to delete a Glossary. */
export type DeleteGlossaryPayload = DeleteGlossarySuccessfulResponse | ErrorResponse;

/** Delete Glossary Successful Response */
export type DeleteGlossarySuccessfulResponse = {
  __typename: 'DeleteGlossarySuccessfulResponse';
  /** The ID of the deleted glossary. */
  deletedId: Scalars['ObjectID']['output'];
  /** Indicates if the deletion was successful. Always true on success. */
  success: Scalars['Boolean']['output'];
};

/** Possible outcomes when attempting to delete a Group. */
export type DeleteGroupPayload = DeleteGroupSuccessfulResponse | ErrorResponse;

/** Response payload after successfully deleting a Group. */
export type DeleteGroupSuccessfulResponse = {
  __typename: 'DeleteGroupSuccessfulResponse';
  /** The ID of the deleted group. */
  deletedId: Scalars['ObjectID']['output'];
  /** Indicates if the deletion was successful. Always true on success. */
  success: Scalars['Boolean']['output'];
};

/** Possible outcomes when attempting to delete a Module Instance. */
export type DeleteModuleInstancePayload = DeleteModuleInstanceSuccessfulResponse | ErrorResponse;

/** Response payload after successfully deleting a Module Instance. */
export type DeleteModuleInstanceSuccessfulResponse = {
  __typename: 'DeleteModuleInstanceSuccessfulResponse';
  deletedId: Scalars['ObjectID']['output'];
  success: Scalars['Boolean']['output'];
};

/** Possible outcomes when attempting to delete a Performance Result. */
export type DeletePerformanceResultPayload = DeletePerformanceResultSuccessfulResponse | ErrorResponse;

/** Response payload after successfully deleting a Performance Result. */
export type DeletePerformanceResultSuccessfulResponse = {
  __typename: 'DeletePerformanceResultSuccessfulResponse';
  deletedId: Scalars['ObjectID']['output'];
  success: Scalars['Boolean']['output'];
};

/** Possible outcomes when attempting to delete a Program. */
export type DeleteProgramPayload = DeleteProgramSuccessfulResponse | ErrorResponse;

/** Response payload after successfully deleting a Program. */
export type DeleteProgramSuccessfulResponse = {
  __typename: 'DeleteProgramSuccessfulResponse';
  /** The ID of the deleted Program. */
  deletedId: Scalars['ObjectID']['output'];
  /** Indicates if the deletion was successful. Always true on success. */
  success: Scalars['Boolean']['output'];
};

/** Possible outcomes when attempting to delete a Subgroup. */
export type DeleteSubgroupPayload = DeleteSubgroupSuccessfulResponse | ErrorResponse;

/** Response payload after successfully deleting a Subgroup. */
export type DeleteSubgroupSuccessfulResponse = {
  __typename: 'DeleteSubgroupSuccessfulResponse';
  /** The ID of the deleted subgroup. */
  deletedId: Scalars['ObjectID']['output'];
  /** Indicates if the deletion was successful. Always true on success. */
  success: Scalars['Boolean']['output'];
};

/** Possible outcomes when attempting to delete a User. */
export type DeleteUserResponse = DeleteUserSuccessfulResponse | ErrorResponse;

/** Response payload after successfully deleting a User. */
export type DeleteUserSuccessfulResponse = {
  __typename: 'DeleteUserSuccessfulResponse';
  /** The ID of the deleted user. */
  deletedId: Scalars['ObjectID']['output'];
  /** Indicates if the deletion was successful. Always true on success. */
  success: Scalars['Boolean']['output'];
};

/** Possible outcomes when requesting to download the template for importing users. */
export type DownloadTemplateImportUsersPayload = DownloadTemplateImportUsersResponse | ErrorResponse;

/** Response payload after successfully requesting to download the template for importing users. */
export type DownloadTemplateImportUsersResponse = {
  __typename: 'DownloadTemplateImportUsersResponse';
  result: ExportResult;
};

/** Represents the duration of a course */
export type Duration = {
  __typename: 'Duration';
  unit: DurationUnit;
  value: Scalars['Int']['output'];
};

/** Input for creating a duration */
export type DurationInput = {
  unit: DurationUnit;
  value: Scalars['Int']['input'];
};

/** Defines the duration unit for a course */
export enum DurationUnit {
  Days = 'Days',
  Months = 'Months',
  Weeks = 'Weeks',
  Years = 'Years'
}

/**
 * Enable Authenticator Response
 *
 * The response may be of two types:
 * - EnableAuthenticatorSuccessfulResponse : in case of success
 * - ErrorResponse : in case of error
 */
export type EnableAuthenticatorResponse = EnableAuthenticatorSuccessfulResponse | ErrorResponse;

/**
 * Enable Authenticator Successful Response
 *
 * This is the response returned from a successful enable authentication request.
 */
export type EnableAuthenticatorSuccessfulResponse = {
  __typename: 'EnableAuthenticatorSuccessfulResponse';
  result: Scalars['Boolean']['output'];
};

/**
 * Error On Field
 *
 * This is the error response type commonly used in the schema.
 */
export type ErrorOnField = {
  __typename: 'ErrorOnField';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/**
 * Error Response
 *
 * This is the error response type commonly used in the schema.
 */
export type ErrorResponse = {
  __typename: 'ErrorResponse';
  fields?: Maybe<Array<ErrorOnField>>;
};

/** Represents a single execution step in a course */
export type ExecutionSequence = {
  __typename: 'ExecutionSequence';
  configuration?: Maybe<ModuleInstanceConfiguration>;
  configurationId?: Maybe<Scalars['ObjectID']['output']>;
  moduleInstance?: Maybe<ModuleInstance>;
  moduleInstanceId: Scalars['ObjectID']['output'];
  order: Scalars['Int']['output'];
};

/** Input for creating an execution sequence */
export type ExecutionSequenceInput = {
  configurationId: Scalars['ObjectID']['input'];
  moduleInstanceId: Scalars['ObjectID']['input'];
  order: Scalars['Int']['input'];
};

/** Possible outcomes when attempting to export assessment results to a CSV file. */
export type ExportAssessmentResultPayload = ErrorResponse | ExportAssessmentResultSuccessfulResponse;

/** Represents the result of a assessment result export operation. */
export type ExportAssessmentResultResult = {
  __typename: 'ExportAssessmentResultResult';
  downloadUrl: Scalars['String']['output'];
};

/** Response payload after successfully exporting assessment result to a CSV file. */
export type ExportAssessmentResultSuccessfulResponse = {
  __typename: 'ExportAssessmentResultSuccessfulResponse';
  result: ExportAssessmentResultResult;
};

/** Possible outcomes when attempting to export performance results to a CSV file. */
export type ExportPerformanceResultPayload = ErrorResponse | ExportPerformanceResultSuccessfulResponse;

/** Represents the result of a performance result export operation. */
export type ExportPerformanceResultResult = {
  __typename: 'ExportPerformanceResultResult';
  downloadUrl: Scalars['String']['output'];
};

/** Response payload after successfully exporting performance result to a CSV file. */
export type ExportPerformanceResultSuccessfulResponse = {
  __typename: 'ExportPerformanceResultSuccessfulResponse';
  result: ExportPerformanceResultResult;
};

/** Represents the result of a user export operation. */
export type ExportResult = {
  __typename: 'ExportResult';
  downloadUrl: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

/** Possible outcomes when attempting to export users to a CSV file. */
export type ExportUsersPayload = ErrorResponse | ExportUsersSuccessfulResponse;

/** Response payload after successfully exporting users to a CSV file. */
export type ExportUsersSuccessfulResponse = {
  __typename: 'ExportUsersSuccessfulResponse';
  result: ExportResult;
};

/** A module definition for an external integration. */
export type ExternalModuleDefinition = BaseModuleDefinition & {
  __typename: 'ExternalModuleDefinition';
  category: ModuleCategory;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupingKey: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  identifier: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  subCategory?: Maybe<ModuleSubCategory>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Specific configuration for an FINSwim module instance. */
export type FinSwimConfiguration = BaseModuleInstanceConfiguration & PhysicalBaseConfiguration & {
  __typename: 'FinSwimConfiguration';
  allowBulkImport: Scalars['Boolean']['output'];
  allowManualEntry: Scalars['Boolean']['output'];
  demoVideo?: Maybe<UploadedFile>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents the result for FINSwim. */
export type FinSwimResult = {
  __typename: 'FinSwimResult';
  timingSec?: Maybe<Scalars['Int']['output']>;
};

/**
 * Input representing the FinSwim assessment result details.
 * Fields are optional to allow partial submissions based on available measurements.
 */
export type FinSwimResultInput = {
  /** FinSwim timing in seconds */
  timingSec?: InputMaybe<Scalars['Int']['input']>;
};

/** Defines the gender options for a user. */
export enum Gender {
  Female = 'Female',
  Male = 'Male',
  NotToSpecify = 'NotToSpecify'
}

/** Input for generating trainer notes via AI agent. */
export type GenerateTrainersNotesInput = {
  assessmentRunId: Scalars['ObjectID']['input'];
  companyId: Scalars['ObjectID']['input'];
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to generate trainer notes via AI. */
export type GenerateTrainersNotesPayload = ErrorResponse | GenerateTrainersNotesSuccessfulResponse;

/** Response payload after successfully generating trainer notes via AI. */
export type GenerateTrainersNotesSuccessfulResponse = {
  __typename: 'GenerateTrainersNotesSuccessfulResponse';
  suggestion: Scalars['String']['output'];
};

/** Glossary term entry. */
export type Glossary = {
  __typename: 'Glossary';
  /** The date and time the glossary item was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created the glossary item. */
  createdBy?: Maybe<User>;
  /** The definition or description of the term. */
  definition: Scalars['String']['output'];
  /** Unique identifier for the glossary term. */
  id: Scalars['ObjectID']['output'];
  /** Soft delete flag. */
  isDeleted: Scalars['Boolean']['output'];
  /** The glossary term. */
  term: Scalars['String']['output'];
  /** The date and time the glossary item was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who last updated the glossary item. */
  updatedBy?: Maybe<User>;
};

/** Filtering options for glossary terms. */
export type GlossaryFilteringRule = {
  /** Filter by case-insensitive substring on term. */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

/** Fields available for sorting Glossary. */
export enum GlossarySortingField {
  CreatedAt = 'CreatedAt',
  Term = 'Term',
  UpdatedAt = 'UpdatedAt'
}

/** Input type for sorting Glossary. */
export type GlossarySortingRule = {
  field: GlossarySortingField;
  order: SortingOrder;
};

/** Group type definition for the core group module. */
export type Group = {
  __typename: 'Group';
  /** All members of the group, including those in subgroups. */
  allMembers: Array<User>;
  /** Company this group belongs to. */
  company: Company;
  /** Company identifier (ObjectId) this group belongs to. */
  companyId: Scalars['ObjectID']['output'];
  /** Timestamp of creation. */
  createdAt: Scalars['DateTime']['output'];
  /** Creator of the group. */
  createdBy?: Maybe<User>;
  /** Group description. */
  description?: Maybe<Scalars['String']['output']>;
  /** List of ObjectIDs representing courses the group is enrolled in. */
  enrolledCourseIds: Array<Scalars['ObjectID']['output']>;
  /** List of courses the group is enrolled in. */
  enrolledCourses: Array<Course>;
  id: Scalars['ObjectID']['output'];
  /** Deletable flag. */
  isDeletable: Scalars['Boolean']['output'];
  /** Soft delete flag. */
  isDeleted: Scalars['Boolean']['output'];
  /** Group name. */
  name: Scalars['String']['output'];
  /** Subgroup count. */
  subgroupCount: Scalars['Int']['output'];
  /** Subgroups of the group. */
  subgroups: Array<Subgroup>;
  /** Total member count across all subgroups. */
  totalMemberCount: Scalars['Int']['output'];
  /** Timestamp of last update. */
  updatedAt: Scalars['DateTime']['output'];
  /** Updater of the group. */
  updatedBy?: Maybe<User>;
};

/** Group filtering rule input. */
export type GroupFilteringRule = {
  /** Filter by company description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Filter by enrolled course instance ID */
  enrolledCourseId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by company name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter across multiple relevant fields (name, description) using a single search term. */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

/** Fields available for sorting Groups. */
export enum GroupSortingField {
  Description = 'Description',
  Id = 'Id',
  MemberCount = 'MemberCount',
  Name = 'Name',
  UpdatedAt = 'UpdatedAt'
}

/** Input type for sorting Groups. */
export type GroupSortingRule = {
  /** The field by which to sort the groups. */
  field: GroupSortingField;
  /** The order in which to sort the groups. */
  order: SortingOrder;
};

/** Available image categories for Visual Reaction assessment. */
export enum ImageCategory {
  Alphabet = 'Alphabet',
  Animals = 'Animals',
  Icons = 'Icons',
  Numbers = 'Numbers',
  Shapes = 'Shapes',
  Transportation = 'Transportation'
}

/** Represents the result of a import assessment result import operation. */
export type ImportAssessmentResult = {
  __typename: 'ImportAssessmentResult';
  /** Return import history ID for tracking the import status. */
  historyId: Scalars['ObjectID']['output'];
};

/** Possible outcomes when importing assessment results from a CSV file. */
export type ImportAssessmentResultPayload = ErrorResponse | ImportAssessmentResultSuccessfulResponse;

/** Response payload importing assessment results from a CSV file. */
export type ImportAssessmentResultSuccessfulResponse = {
  __typename: 'ImportAssessmentResultSuccessfulResponse';
  result: ImportAssessmentResult;
};

/** Import history record. */
export type ImportHistory = {
  __typename: 'ImportHistory';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ObjectID']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  errors: Array<ImportHistoryRowError>;
  file?: Maybe<UploadedFile>;
  id: Scalars['ObjectID']['output'];
  importedRowIndex: Scalars['Int']['output'];
  jobId?: Maybe<Scalars['String']['output']>;
  progress: Scalars['Float']['output'];
  status: ImportHistoryStatus;
};

/** Input type for filtering import history records. */
export type ImportHistoryFilteringRule = {
  createdBy?: InputMaybe<Scalars['ObjectID']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ImportHistoryStatus>;
};

/** Import history error record. */
export type ImportHistoryRowError = {
  __typename: 'ImportHistoryRowError';
  field: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  rowNumber: Scalars['Int']['output'];
};

/**
 * Enum for available fields to sort import history records.
 * - Status: Sort by import status (pending, completed, etc.)
 * - CreatedAt: Sort by creation date/time
 */
export enum ImportHistorySortField {
  CreatedAt = 'CreatedAt',
  Status = 'Status'
}

/** Defines the sorting rule for a list of ImportHistory, specifying the field and direction. */
export type ImportHistorySortingRule = {
  field: ImportHistorySortField;
  order: SortingOrder;
};

/**
 * Enum for the status of an import history record.
 * - Pending: Import job is queued and has not started.
 * - InProgress: Import job is currently running.
 * - Paused: Import job has been paused by the user or system.
 * - Failed: Import job has failed due to an error.
 * - Completed: Import job finished successfully.
 */
export enum ImportHistoryStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Paused = 'Paused',
  Pending = 'Pending'
}

/** Represents the result of a import performance result import operation. */
export type ImportPerformanceResult = {
  __typename: 'ImportPerformanceResult';
  /** Return import history ID for tracking the import status. */
  historyId: Scalars['ObjectID']['output'];
};

/** Possible outcomes when importing performance results from a CSV file. */
export type ImportPerformanceResultPayload = ErrorResponse | ImportPerformanceResultSuccessfulResponse;

/** Response payload importing performance results from a CSV file. */
export type ImportPerformanceResultSuccessfulResponse = {
  __typename: 'ImportPerformanceResultSuccessfulResponse';
  result: ImportPerformanceResult;
};

/** Imported row error details. */
export type ImportRowError = {
  __typename: 'ImportRowError';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
};

/** Possible outcomes when attempting to import users from a CSV file. */
export type ImportUsersPayload = ErrorResponse | ImportUsersSuccessfulResponse;

/** Possible outcomes when attempting to import users from a CSV file. */
export type ImportUsersProgressPayload = ErrorResponse | ImportUsersProgressSuccessfulResponse;

/** Progress of users import job */
export type ImportUsersProgressResult = {
  __typename: 'ImportUsersProgressResult';
  importHistoryId: Scalars['ObjectID']['output'];
  jobId: Scalars['String']['output'];
  progress: Scalars['Float']['output'];
  status: ImportHistoryStatus;
};

/** Response payload after successfully importing users from a CSV file. */
export type ImportUsersProgressSuccessfulResponse = {
  __typename: 'ImportUsersProgressSuccessfulResponse';
  result: ImportUsersProgressResult;
};

/** Represents the result of a user export operation. */
export type ImportUsersResult = {
  __typename: 'ImportUsersResult';
  createNewCount?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<ImportRowError>>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  readyUpdatedCount?: Maybe<Scalars['Int']['output']>;
  status: ImportUsersStatus;
  totalRows?: Maybe<Scalars['Int']['output']>;
};

/** Defines the status options for importing users. */
export enum ImportUsersStatus {
  Skipped = 'Skipped',
  Success = 'Success'
}

/** Response payload after successfully importing users from a CSV file. */
export type ImportUsersSuccessfulResponse = {
  __typename: 'ImportUsersSuccessfulResponse';
  result: ImportUsersResult;
};

/** Specific configuration for an InbodyComposition module instance. */
export type InbodyCompositionConfiguration = BaseModuleInstanceConfiguration & PhysicalBaseConfiguration & {
  __typename: 'InbodyCompositionConfiguration';
  allowBulkImport: Scalars['Boolean']['output'];
  allowManualEntry: Scalars['Boolean']['output'];
  demoVideo?: Maybe<UploadedFile>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents the result for InbodyComposition. */
export type InbodyCompositionResult = {
  __typename: 'InbodyCompositionResult';
  bodyFatMassKg?: Maybe<Scalars['Float']['output']>;
  bodyFatPercentage?: Maybe<Scalars['Float']['output']>;
  fatFreeMassKg?: Maybe<Scalars['Float']['output']>;
  ffmOfLeftArmKg?: Maybe<Scalars['Float']['output']>;
  ffmOfLeftArmPercentage?: Maybe<Scalars['Float']['output']>;
  ffmOfLeftLegKg?: Maybe<Scalars['Float']['output']>;
  ffmOfLeftLegPercentage?: Maybe<Scalars['Float']['output']>;
  ffmOfRightArmKg?: Maybe<Scalars['Float']['output']>;
  ffmOfRightArmPercentage?: Maybe<Scalars['Float']['output']>;
  ffmOfRightLegKg?: Maybe<Scalars['Float']['output']>;
  ffmOfRightLegPercentage?: Maybe<Scalars['Float']['output']>;
  ffmOfTrunkKg?: Maybe<Scalars['Float']['output']>;
  ffmOfTrunkPercentage?: Maybe<Scalars['Float']['output']>;
  skeletalMuscleMassKg?: Maybe<Scalars['Float']['output']>;
  totalBodyWater?: Maybe<Scalars['Float']['output']>;
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/**
 * Input representing the Inbody Composition assessment result details.
 * Fields are optional to allow partial submissions based on available measurements.
 */
export type InbodyCompositionResultInput = {
  bodyFatMassKg?: InputMaybe<Scalars['Float']['input']>;
  bodyFatPercentage?: InputMaybe<Scalars['Float']['input']>;
  fatFreeMassKg?: InputMaybe<Scalars['Float']['input']>;
  ffmOfLeftArmKg?: InputMaybe<Scalars['Float']['input']>;
  ffmOfLeftArmPercentage?: InputMaybe<Scalars['Float']['input']>;
  ffmOfLeftLegKg?: InputMaybe<Scalars['Float']['input']>;
  ffmOfLeftLegPercentage?: InputMaybe<Scalars['Float']['input']>;
  ffmOfRightArmKg?: InputMaybe<Scalars['Float']['input']>;
  ffmOfRightArmPercentage?: InputMaybe<Scalars['Float']['input']>;
  ffmOfRightLegKg?: InputMaybe<Scalars['Float']['input']>;
  ffmOfRightLegPercentage?: InputMaybe<Scalars['Float']['input']>;
  ffmOfTrunkKg?: InputMaybe<Scalars['Float']['input']>;
  ffmOfTrunkPercentage?: InputMaybe<Scalars['Float']['input']>;
  skeletalMuscleMassKg?: InputMaybe<Scalars['Float']['input']>;
  totalBodyWater?: InputMaybe<Scalars['Float']['input']>;
  weightKg?: InputMaybe<Scalars['Float']['input']>;
};

/** Input type for an Individual Motivation assessment result. */
export type IndividualMotivationAssessmentResultInput = {
  surveys: Array<IndividualMotivationSurveyResultInput>;
};

/** Represents the aggregated score for a category, including a breakdown by subcategory. */
export type IndividualMotivationCategoryBreakdown = {
  __typename: 'IndividualMotivationCategoryBreakdown';
  averageScore: Scalars['Float']['output'];
  category: Scalars['String']['output'];
  maximumPossibleScore: Scalars['Int']['output'];
  subcategoryAverages: Array<IndividualMotivationSubcategoryAverage>;
};

/** Specific configuration for an Individual Motivation module instance. */
export type IndividualMotivationModuleInstanceConfiguration = BaseModuleInstanceConfiguration & {
  __typename: 'IndividualMotivationModuleInstanceConfiguration';
  demoVideo?: Maybe<UploadedFile>;
  instructionMobile?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  questions: Array<IndividualMotivationQuestion>;
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/** Input type for Individual Motivation module instance configuration. */
export type IndividualMotivationModuleInstanceConfigurationInput = {
  instructionMobile?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfQuestions: Scalars['Int']['input'];
  questions: Array<IndividualMotivationQuestionInput>;
  reminders?: InputMaybe<Scalars['String']['input']>;
  showDemoVideo: Scalars['Boolean']['input'];
};

/** A question in the Individual Motivation module. */
export type IndividualMotivationQuestion = {
  __typename: 'IndividualMotivationQuestion';
  category: Scalars['String']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  scaleResponseType: ResponseType;
  subcategory: Scalars['String']['output'];
};

/** Input type for anIndividual Motivation question. */
export type IndividualMotivationQuestionInput = {
  category: Scalars['String']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  scaleResponseType: ResponseTypeInput;
  subcategory: Scalars['String']['input'];
};

/** Represents the aggregated Individual Motivation result. */
export type IndividualMotivationResult = {
  __typename: 'IndividualMotivationResult';
  categoryBreakdowns: Array<IndividualMotivationCategoryBreakdown>;
  surveys: Array<IndividualMotivationSurveyResult>;
};

/** Represents the average score for a subcategory within a category. */
export type IndividualMotivationSubcategoryAverage = {
  __typename: 'IndividualMotivationSubcategoryAverage';
  averageScore: Scalars['Float']['output'];
  maximumPossibleScore: Scalars['Int']['output'];
  subcategory: Scalars['String']['output'];
};

/** Represents a single Individual Motivation survey result. */
export type IndividualMotivationSurveyResult = {
  __typename: 'IndividualMotivationSurveyResult';
  category: Scalars['String']['output'];
  question: Scalars['String']['output'];
  scoring: ResponseResult;
  subcategory: Scalars['String']['output'];
};

/** Input type for an Individual Motivation survey result. */
export type IndividualMotivationSurveyResultInput = {
  category: Scalars['String']['input'];
  question: Scalars['String']['input'];
  scoring: ResponseResultInput;
  subcategory: Scalars['String']['input'];
};

/**
 * Invite Response
 *
 * The response may be of two types:
 * - InviteSuccessfulResponse : in case of success
 * - ErrorResponse : in case of error
 */
export type InviteResponse = ErrorResponse | InviteSuccessfulResponse;

/**
 * Invite Successful Response
 *
 * This is the response returned from a successful invite request.
 */
export type InviteSuccessfulResponse = {
  __typename: 'InviteSuccessfulResponse';
  result?: Maybe<Scalars['Boolean']['output']>;
};

/** Invitee */
export type Invitee = {
  __typename: 'Invitee';
  company?: Maybe<Company>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  height?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/** Union type for invitee response. */
export type InviteeResponse = ErrorResponse | InviteeSuccessResponse;

/** Invitee success response. */
export type InviteeSuccessResponse = {
  __typename: 'InviteeSuccessResponse';
  invitee?: Maybe<Invitee>;
};

/** Specific configuration for an IPPT module instance. */
export type IpptConfiguration = BaseModuleInstanceConfiguration & PhysicalBaseConfiguration & {
  __typename: 'IpptConfiguration';
  allowBulkImport: Scalars['Boolean']['output'];
  allowManualEntry: Scalars['Boolean']['output'];
  demoVideo?: Maybe<UploadedFile>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents the result for IPPT. */
export type IpptResult = {
  __typename: 'IpptResult';
  award?: Maybe<AwardResult>;
  points?: Maybe<Scalars['Int']['output']>;
  pullUps?: Maybe<Scalars['Int']['output']>;
  pushUps?: Maybe<Scalars['Int']['output']>;
  runTimeSec?: Maybe<Scalars['Int']['output']>;
  sitUps?: Maybe<Scalars['Int']['output']>;
};

/**
 * Input representing the IPPT assessment result details.
 * Fields are optional to allow partial submissions based on available measurements.
 */
export type IpptResultInput = {
  /** Total points awarded for IPPT. */
  points?: InputMaybe<Scalars['Int']['input']>;
  /** Number of pull-ups completed (if applicable to protocol variant). */
  pullUps?: InputMaybe<Scalars['Int']['input']>;
  /** Number of push-ups completed within the test protocol. */
  pushUps?: InputMaybe<Scalars['Int']['input']>;
  /** 2.4km run time in seconds. */
  runTimeSec?: InputMaybe<Scalars['Int']['input']>;
  /** Number of sit-ups completed within the test protocol. */
  sitUps?: InputMaybe<Scalars['Int']['input']>;
};

/** The type of a response to a Likert scale question. */
export type LikertScaleResponse = {
  __typename: 'LikertScaleResponse';
  responseType: PsychologicalQuestionResponseType;
  scoring: Array<Scoring>;
};

/** Input type for a Likert scale response. */
export type LikertScaleResponseInput = {
  responseType: PsychologicalQuestionResponseType;
  scoring: Array<ScoringInput>;
};

/** Represents a single Likert scale result. */
export type LikertScaleResult = {
  __typename: 'LikertScaleResult';
  label: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  type: ResponseResultType;
};

/** Input type for a Likert scale result. */
export type LikertScaleResultInput = {
  label: Scalars['String']['input'];
  score: Scalars['Int']['input'];
  total: Scalars['Int']['input'];
};

/** Input representing the aggregated ML360 assessment result. */
export type Ml360AssessmentResultInput = {
  surveys: Array<Ml360SurveyResultInput>;
};

/** Represents the result of a single survey category in ML360. */
export type Ml360CategoryResult = {
  __typename: 'ML360CategoryResult';
  averageScore: Scalars['Float']['output'];
  category: Scalars['String']['output'];
  maxScore: Scalars['Int']['output'];
};

/** Specific configuration for an ML360 module instance. */
export type Ml360ModuleInstanceConfiguration = BaseModuleInstanceConfiguration & {
  __typename: 'ML360ModuleInstanceConfiguration';
  demoVideo?: Maybe<UploadedFile>;
  instructionMobile?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  questions: Array<Ml360Question>;
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/** Input type for ML360 module instance configuration. */
export type Ml360ModuleInstanceConfigurationInput = {
  instructionMobile?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfQuestions: Scalars['Int']['input'];
  questions: Array<Ml360QuestionInput>;
  reminders?: InputMaybe<Scalars['String']['input']>;
  showDemoVideo: Scalars['Boolean']['input'];
};

/** Represents the aggregated result for ML360. */
export type Ml360Result = {
  __typename: 'ML360Result';
  categoryAverages: Array<Ml360CategoryResult>;
  surveys: Array<Ml360SurveyResult>;
};

/** Represents the result of a single survey question in ML360. */
export type Ml360SurveyResult = {
  __typename: 'ML360SurveyResult';
  category: Scalars['String']['output'];
  question: Scalars['String']['output'];
  scoring: Scoring;
};

/** Input representing a single survey result for ML360. */
export type Ml360SurveyResultInput = {
  category: Scalars['String']['input'];
  question: Scalars['String']['input'];
  scoring: ScoringInput;
};

/** MSAL Configuration */
export type MsalConfiguration = {
  __typename: 'MSALConfiguration';
  /** Authority URL */
  authority: Scalars['String']['output'];
  /** Callback URL */
  callback: Scalars['String']['output'];
  /** Client ID */
  clientId: Scalars['String']['output'];
  /** If true, the MSAL configuration is enforced over basic authentication. */
  enforced: Scalars['Boolean']['output'];
};

/** MSAL Configuration */
export type MsalConfigurationInput = {
  /** Authority URL */
  authority: Scalars['String']['input'];
  /** Client ID */
  clientId: Scalars['String']['input'];
  /** Client Secret */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** If true, the MSAL configuration is enforced over basic authentication. */
  enforced: Scalars['Boolean']['input'];
};

/** Specific configuration for an 20Km combat march module instance. */
export type March20KmConfiguration = BaseModuleInstanceConfiguration & PhysicalBaseConfiguration & {
  __typename: 'March20KmConfiguration';
  allowBulkImport: Scalars['Boolean']['output'];
  allowManualEntry: Scalars['Boolean']['output'];
  demoVideo?: Maybe<UploadedFile>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Input representing the 20km Road March assessment result details.
 * Fields are optional to allow partial submissions based on available measurements.
 */
export type March20KmResultInput = {
  /** Pass/Fail result for the 20km Road March. */
  result?: InputMaybe<PassFailResult>;
  /** 20km Road March timing in seconds. */
  timingSec?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the result for 20Km combat march. */
export type March20kmResult = {
  __typename: 'March20kmResult';
  result?: Maybe<PassFailResult>;
  timingSec?: Maybe<Scalars['Int']['output']>;
};

/** Display format options for the memorization phase. */
export enum MemorizationPhaseDisplayFormat {
  Animations = 'Animations',
  StaticImages = 'StaticImages',
  Video = 'Video'
}

/** A question in the ML360 module. */
export type Ml360Question = {
  __typename: 'Ml360Question';
  category: Scalars['String']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  scaleResponseType: ResponseType;
};

/** Input type for a ML360 question. */
export type Ml360QuestionInput = {
  category: Scalars['String']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  scaleResponseType: ResponseTypeInput;
};

/** The category of a module. */
export enum ModuleCategory {
  Assessment = 'Assessment',
  External = 'External',
  Reporting = 'Reporting',
  Training = 'Training'
}

/** A module definition. */
export type ModuleDefinition = AssessmentModuleDefinition | ExternalModuleDefinition | ReportingModuleDefinition | TrainingModuleDefinition;

/**
 * Input for filtering available module definitions.
 * Allows filtering by categories and sub-categories.
 */
export type ModuleDefinitionFilteringRule = {
  /** Whether the module can be created from scratch. */
  canBeCreatedFromScratch?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of module categories to filter by. */
  categories?: InputMaybe<Array<ModuleCategory>>;
  /** Filter by module identifier */
  identifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by module name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Search text to filter by name or description. */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** A list of module sub-categories to filter by. */
  subCategories?: InputMaybe<Array<ModuleSubCategory>>;
};

/** Fields available for sorting module definitions. */
export enum ModuleDefinitionSortingField {
  CreatedAt = 'CreatedAt',
  Name = 'Name',
  UpdatedAt = 'UpdatedAt'
}

/** Input type for sorting module definitions. */
export type ModuleDefinitionSortingRule = {
  field: ModuleDefinitionSortingField;
  order: SortingOrder;
};

/**
 * Represents a specific, user-configured module instance,
 * based on a master module from the marketplace.
 */
export type ModuleInstance = {
  __typename: 'ModuleInstance';
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['ObjectID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  currentConfiguration: ModuleInstanceConfiguration;
  currentConfigurationId: Scalars['ObjectID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  isDefault: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  moduleDefinition?: Maybe<ModuleDefinition>;
  moduleDefinitionIdentifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

/** A union type for module configurations. */
export type ModuleInstanceConfiguration = BmpConfiguration | CardioRespConfiguration | FinSwimConfiguration | InbodyCompositionConfiguration | IndividualMotivationModuleInstanceConfiguration | IpptConfiguration | Ml360ModuleInstanceConfiguration | March20KmConfiguration | SartModuleInstanceConfiguration | SelfDeterminationModuleInstanceConfiguration | SocConfiguration | SpatialPlanningModuleInstanceConfiguration | StrengthConfiguration | TeamResilienceModuleInstanceConfiguration | VisualReactionModuleInstanceConfiguration | WeightConfiguration;

/**
 * A tagged union input type for module configurations.
 * Exactly one of the fields must be provided.
 */
export type ModuleInstanceConfigurationInput = {
  individualMotivation?: InputMaybe<IndividualMotivationModuleInstanceConfigurationInput>;
  ml360?: InputMaybe<Ml360ModuleInstanceConfigurationInput>;
  sart?: InputMaybe<SartModuleInstanceConfigurationInput>;
  selfDetermination?: InputMaybe<SelfDeterminationModuleInstanceConfigurationInput>;
  spatialPlanning?: InputMaybe<SpatialPlanningModuleInstanceConfigurationInput>;
  teamResilience?: InputMaybe<TeamResilienceModuleInstanceConfigurationInput>;
  visualReaction?: InputMaybe<VisualReactionModuleInstanceConfigurationInput>;
};

/**
 * An enum for the different types of module instance configurations.
 * Add new values here when new module instance configurations are added.
 */
export enum ModuleInstanceConfigurationType {
  Bmp = 'BMP',
  CardioResp = 'CardioResp',
  FinSwim = 'FINSwim',
  Ippt = 'IPPT',
  InbodyComposition = 'InbodyComposition',
  IndividualMotivation = 'IndividualMotivation',
  Ml360 = 'ML360',
  March20km = 'March20km',
  Sart = 'SART',
  Soc = 'SOC',
  SelfDetermination = 'SelfDetermination',
  SpatialPlanning = 'SpatialPlanning',
  Strength = 'Strength',
  TeamResilience = 'TeamResilience',
  VisualReaction = 'VisualReaction',
  Weight = 'Weight'
}

/** Input type for filtering Module Instances. */
export type ModuleInstanceFilterRule = {
  categories?: InputMaybe<Array<ModuleCategory>>;
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  subCategories?: InputMaybe<Array<ModuleSubCategory>>;
};

/** Module Instance Launch Item */
export type ModuleInstanceLaunchItem = {
  __typename: 'ModuleInstanceLaunchItem';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  moduleInstance: ModuleInstance;
  resultId?: Maybe<Scalars['ObjectID']['output']>;
  targetFullName: Scalars['String']['output'];
  /** The user ID of the target user for the module instance. */
  targetUserId: Scalars['ObjectID']['output'];
};

/** Fields available for sorting Module Instances. */
export enum ModuleInstanceSortingField {
  CreatedAt = 'CreatedAt',
  Name = 'Name',
  UpdatedAt = 'UpdatedAt'
}

/** Input type for sorting Module Instances. */
export type ModuleInstanceSortingRule = {
  field: ModuleInstanceSortingField;
  order: SortingOrder;
};

/** Snapshot of a module configuration as used in a specific assessment run. */
export type ModuleSnapshot = {
  __typename: 'ModuleSnapshot';
  configuration: ModuleInstanceConfiguration;
  configurationId: Scalars['ObjectID']['output'];
  moduleInstance: ModuleInstance;
  moduleInstanceId: Scalars['ObjectID']['output'];
};

/** The subcategory of a module. */
export enum ModuleSubCategory {
  Cognitive = 'Cognitive',
  Integration = 'Integration',
  Performance = 'Performance',
  Physical = 'Physical',
  Psychological = 'Psychological'
}

/** Mutations */
export type Mutation = {
  __typename: 'Mutation';
  /** Activates a user account. */
  activateUser: ActivateUserResponse;
  /** Mutation to authenticate after completing 2FA setup using a setup token */
  authenticateWith2FASetupToken: BasicAuthenticationResponse;
  /** Mutation to authenticate with Microsoft Authentication Library (MSAL) using a code */
  authenticateWithMSAL: BasicAuthenticationResponse;
  /** Mutation to authenticate with OpenID Connect (OIDC) using a code and optional state */
  authenticateWithOIDC: BasicAuthenticationResponse;
  /** Mutation to authenticate with a one-time password (OTP) and password */
  authenticateWithOtp: BasicAuthenticationResponse;
  /** Mutation to authenticate using a reset password token and new password */
  authenticateWithResetPassword: BasicAuthenticationResponse;
  /** Cancels an invitation to a company. */
  cancelInvitation: CancelInvitationPayload;
  /** Mutation to change the user's email to a new email */
  changeEmail: ChangeEmailResponse;
  /** Mutation to change the user's password from current to new password */
  changePassword: ChangePasswordResponse;
  /** Mutation to confirm the new email with password and new email */
  confirmEmail: ConfirmEmailResponse;
  /** Create a new Assessment Run for a Program. */
  createAssessmentRuns: CreateAssessmentRunsPayload;
  /** Creates a new Company (tenant). */
  createCompany: CreateCompanyPayload;
  /**
   * Create a course instance from scratch (custom course).
   * Requires defining the execution sequence manually.
   */
  createCourseInstanceCustom: CreateCourseInstancePayload;
  /**
   * Create a course instance from an existing template.
   * Creates a snapshot of the template at the specified version.
   */
  createCourseInstanceFromTemplate: CreateCourseInstancePayload;
  /** Create a new course template. */
  createCourseTemplate: CreateCourseTemplatePayload;
  /** Create a new glossary item. */
  createGlossary: CreateGlossaryPayload;
  /** Creates a new Group. */
  createGroup: CreateGroupPayload;
  /** Creates a new module instance from a module definition. */
  createModuleInstance: CreateModuleInstancePayload;
  /**
   * Create a new Program.
   * Accepts input data and returns the created Program entity wrapped in a response object.
   */
  createProgram: CreateProgramPayload;
  /** Creates a new Subgroup within a Group. */
  createSubgroup: CreateSubgroupPayload;
  /** Creates a new user. */
  createUser: CreateUserResponse;
  /** Deactivates a user account. */
  deactivateUser: DeactivateUserResponse;
  /** Physical Results */
  deleteAssessmentResult: DeleteAssessmentResultPayload;
  /** Delete an Assessment Runs by GroupId. */
  deleteAssessmentRuns: DeleteAssessmentRunsPayload;
  /** Deletes a Company. */
  deleteCompany: DeleteCompanyPayload;
  /** Delete a course instance (soft delete). */
  deleteCourseInstance: DeleteCourseInstancePayload;
  /** Delete a course template version (soft delete). */
  deleteCourseTemplate: DeleteCourseTemplatePayload;
  /**
   * Delete all versions of a course template series (soft delete).
   * Deletes all template versions that share the same name.
   */
  deleteCourseTemplateSeries: DeleteCourseTemplateSeriesPayload;
  /** Delete demo video */
  deleteDemoVideo: UploadFilePayload;
  /** Delete a glossary item and return true if the operation was successful. */
  deleteGlossary: DeleteGlossaryPayload;
  /** Deletes a Group. */
  deleteGroup: DeleteGroupPayload;
  /** Delete image */
  deleteImage: UploadFilePayload;
  /** Deletes a module instance (soft delete). */
  deleteModuleInstance: DeleteModuleInstancePayload;
  deletePerformanceResult: DeletePerformanceResultPayload;
  /**
   * Delete a Program.
   * Accepts the Program ID and returns a response indicating success or failure.
   */
  deleteProgram: DeleteProgramPayload;
  /** Delete image */
  deleteRxnImage: UploadFilePayload;
  /** Deletes a Subgroup. */
  deleteSubgroup: DeleteSubgroupPayload;
  /** Deletes a user. */
  deleteUser: DeleteUserResponse;
  /** Mutation to disable the authenticator */
  disableAuthenticator: Scalars['Boolean']['output'];
  /** Downloads a template file for import users. */
  downloadTemplateImportUsers: DownloadTemplateImportUsersPayload;
  /**
   * Duplicates an existing module instance to create a new one.
   * The name of the duplicated instance will be prefixed with "Copy of ".
   */
  duplicateModuleInstance: CreateModuleInstancePayload;
  /** Mutation to enable an authenticator using a code and optional token for 2FA setup flow */
  enableAuthenticator: EnableAuthenticatorResponse;
  /** Exports users in bulk to a CSV file. */
  exportUsers: ExportUsersPayload;
  /** Mutation to extend the current session */
  extendSession: Scalars['String']['output'];
  /** Generate trainer notes suggestion via AI Agent (Bedrock). Does not persist. */
  generateTrainersNotes: GenerateTrainersNotesPayload;
  /** import assessment results from a CSV file. */
  importAssessmentResult: ImportAssessmentResultPayload;
  /** import performance results from a CSV file. */
  importPerformanceResult: ImportPerformanceResultPayload;
  /** Imports users in bulk from a CSV file. */
  importUsers: ImportUsersPayload;
  /** Invites a user to a company. */
  invite: InviteResponse;
  /** No-Operation Mutation */
  noop?: Maybe<Scalars['Boolean']['output']>;
  /** Reinvite user to a company. */
  reinviteUser: InviteResponse;
  /** Renews a company subscription. */
  renewCompanySubscription: UpdateCompanyPayload;
  /** Mutation to request a new password for a given email */
  requestNewPassword: RequestNewPasswordResponse;
  /** Mutation to reset password using a token and new password */
  resetPassword: ResetPasswordResponse;
  /** Mutation to revoke a session by its ID */
  revokeSession: Scalars['Boolean']['output'];
  /** Mutation to run basic authentication with email, password */
  runBasicAuthentication: BasicAuthenticationResponse;
  /** Mutation to sign up a new user */
  signUp: SignUpResponse;
  /** BMP Results */
  submitBmpResult: SubmitBmpResultPayload;
  /** Cardio Resp Results */
  submitCardioRespResult: SubmitCardioRespResultPayload;
  /** FinSwim Results */
  submitFinSwimResult: SubmitFinSwimResultPayload;
  /** Inbody Composition Results */
  submitInbodyCompositionResult: SubmitInbodyCompositionResultPayload;
  submitIndividualMotivationAssessmentResult: SubmitIndividualMotivationAssessmentResultPayload;
  /** IPPT Results */
  submitIpptResult: SubmitIpptResultPayload;
  submitML360AssessmentResult: SubmitMl360AssessmentResultPayload;
  /** 20Km Road March Results */
  submitMarch20KmResult: SubmitMarch20KmResultPayload;
  submitSartAssessmentResult: SubmitSartAssessmentResultPayload;
  submitSelfDeterminationAssessmentResult: SubmitSelfDeterminationAssessmentResultPayload;
  /** SOC Results */
  submitSocResult: SubmitSocResultPayload;
  submitSpatialPlanningAssessmentResult: SubmitSpatialPlanningAssessmentResultPayload;
  /** Strength Results */
  submitStrengthResult: SubmitStrengthResultPayload;
  submitTeamResilienceAssessmentResult: SubmitTeamResilienceAssessmentResultPayload;
  /** Trainers Notes Results */
  submitTrainersNotesResult: SubmitTrainersNotesResultPayload;
  submitVisualReactionAssessmentResult: SubmitVisualReactionAssessmentResultPayload;
  /** Weight Results */
  submitWeightResult: SubmitWeightResultPayload;
  /**
   * Allows super admins to switch to a different company context.
   * Returns a new token with the selected company.
   */
  switchCompany: SwitchCompanyResponse;
  /** Update an existing Assessment Run. */
  updateAssessmentRuns: UpdateAssessmentRunsPayload;
  updateBmpResult: UpdateBmpResultPayload;
  updateCardioRespResult: UpdateCardioRespResultPayload;
  /**
   * Updates an existing Company.
   * The company name cannot be changed.
   */
  updateCompany: UpdateCompanyPayload;
  /** Update an existing course instance. */
  updateCourseInstance: UpdateCourseInstancePayload;
  /** Update an existing course template. */
  updateCourseTemplate: UpdateCourseTemplatePayload;
  updateFinSwimResult: UpdateFinSwimResultPayload;
  /** Update an existing glossary item. */
  updateGlossary: UpdateGlossaryPayload;
  /** Updates an existing Group. */
  updateGroup: UpdateGroupPayload;
  updateInbodyCompositionResult: UpdateInbodyCompositionResultPayload;
  updateIpptResult: UpdateIpptResultPayload;
  updateMarch20KmResult: UpdateMarch20KmResultPayload;
  /** Updates an existing module instance. */
  updateModuleInstance: UpdateModuleInstancePayload;
  /** Mutation to update the user's profile with a new name */
  updateProfile: UpdateProfileResponse;
  /**
   * Update an existing Program.
   * Accepts the Program ID and updated input data, returns the updated entity in a response object.
   */
  updateProgram: UpdateProgramPayload;
  updateSSOConfiguration: UpdateSsoResponse;
  updateSocResult: UpdateSocResultPayload;
  updateStrengthResult: UpdateStrengthResultPayload;
  /** Updates an existing Subgroup. */
  updateSubgroup: UpdateSubgroupPayload;
  updateTrainersNotesResult: UpdateTrainersNotesResultPayload;
  /** Updates an existing user. */
  updateUser: UpdateUserPayload;
  /**
   * Updates a user's consent status.
   * Only applies to TenantUsers.
   */
  updateUserConsent: UpdateUserConsentResponse;
  updateWeightResult: UpdateWeightResultPayload;
  /** Upload or replace demo video */
  uploadDemoVideo: UploadFilePayload;
  /** Upload image (for spatial planning) */
  uploadImage: UploadFilePayload;
  /** Upload image (for visual rxn) */
  uploadRxnImage: UploadFilePayload;
  /** Validates imported assessment results from a CSV file. */
  validateImportAssessmentResult: ValidateImportAssessmentResultPayload;
  /** Validates imported performance results from a CSV file. */
  validateImportPerformanceResult: ValidateImportPerformanceResultPayload;
  /** Validates imported users from a CSV file. */
  validateImportUsers: ValidateImportUsersPayload;
  /** Mutation to verify OTP and new email */
  verifyOtp: VerifyOtpResponse;
};


/** Mutations */
export type MutationActivateUserArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationAuthenticateWith2FaSetupTokenArgs = {
  code: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** Mutations */
export type MutationAuthenticateWithMsalArgs = {
  code: Scalars['String']['input'];
};


/** Mutations */
export type MutationAuthenticateWithOidcArgs = {
  code: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


/** Mutations */
export type MutationAuthenticateWithOtpArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** Mutations */
export type MutationAuthenticateWithResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** Mutations */
export type MutationCancelInvitationArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationChangeEmailArgs = {
  newEmail: Scalars['String']['input'];
};


/** Mutations */
export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


/** Mutations */
export type MutationConfirmEmailArgs = {
  newEmail: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


/** Mutations */
export type MutationCreateAssessmentRunsArgs = {
  companyId: Scalars['ObjectID']['input'];
  input: CreateAssessmentRunsInput;
};


/** Mutations */
export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


/** Mutations */
export type MutationCreateCourseInstanceCustomArgs = {
  input: CreateCourseInstanceCustomInput;
};


/** Mutations */
export type MutationCreateCourseInstanceFromTemplateArgs = {
  input: CreateCourseInstanceFromTemplateInput;
};


/** Mutations */
export type MutationCreateCourseTemplateArgs = {
  input: CreateCourseTemplateInput;
};


/** Mutations */
export type MutationCreateGlossaryArgs = {
  input: CreateGlossaryInput;
};


/** Mutations */
export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


/** Mutations */
export type MutationCreateModuleInstanceArgs = {
  input: CreateModuleInstanceInput;
};


/** Mutations */
export type MutationCreateProgramArgs = {
  companyId: Scalars['ObjectID']['input'];
  input: CreateProgramInput;
};


/** Mutations */
export type MutationCreateSubgroupArgs = {
  input: CreateSubgroupInput;
};


/** Mutations */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** Mutations */
export type MutationDeactivateUserArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeleteAssessmentResultArgs = {
  companyId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeleteAssessmentRunsArgs = {
  companyId: Scalars['ObjectID']['input'];
  groupId: Scalars['ObjectID']['input'];
  programId: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeleteCompanyArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeleteCourseInstanceArgs = {
  companyId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeleteCourseTemplateArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeleteCourseTemplateSeriesArgs = {
  name: Scalars['String']['input'];
};


/** Mutations */
export type MutationDeleteDemoVideoArgs = {
  bumpVersion: Scalars['Boolean']['input'];
  moduleInstanceId: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeleteGlossaryArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeleteGroupArgs = {
  companyId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeleteImageArgs = {
  bumpVersion: Scalars['Boolean']['input'];
  imageId: Scalars['ObjectID']['input'];
  moduleInstanceId: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeleteModuleInstanceArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeletePerformanceResultArgs = {
  companyId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeleteProgramArgs = {
  companyId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeleteRxnImageArgs = {
  bumpVersion: Scalars['Boolean']['input'];
  imageId: Scalars['ObjectID']['input'];
  moduleInstanceId: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeleteSubgroupArgs = {
  companyId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDeleteUserArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationDuplicateModuleInstanceArgs = {
  id: Scalars['ObjectID']['input'];
  input: CreateModuleInstanceInput;
};


/** Mutations */
export type MutationEnableAuthenticatorArgs = {
  token: Scalars['String']['input'];
};


/** Mutations */
export type MutationExportUsersArgs = {
  companyId: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationGenerateTrainersNotesArgs = {
  input: GenerateTrainersNotesInput;
};


/** Mutations */
export type MutationImportAssessmentResultArgs = {
  assessmentRunId: Scalars['ObjectID']['input'];
  file: Scalars['Upload']['input'];
  moduleId: Scalars['ObjectID']['input'];
  resultType: AssessmentResultType;
  size: Scalars['Int']['input'];
};


/** Mutations */
export type MutationImportPerformanceResultArgs = {
  file: Scalars['Upload']['input'];
  resultType: PerformanceResultType;
  size: Scalars['Int']['input'];
};


/** Mutations */
export type MutationImportUsersArgs = {
  companyId: Scalars['ObjectID']['input'];
  file: Scalars['Upload']['input'];
};


/** Mutations */
export type MutationInviteArgs = {
  assignedGroups?: InputMaybe<Array<AssignedGroupInput>>;
  companyId: Scalars['ObjectID']['input'];
  email: Scalars['String']['input'];
  role: UserRole;
};


/** Mutations */
export type MutationReinviteUserArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationRenewCompanySubscriptionArgs = {
  id: Scalars['ObjectID']['input'];
  input: NewCompanySubscriptionInput;
};


/** Mutations */
export type MutationRequestNewPasswordArgs = {
  email: Scalars['String']['input'];
};


/** Mutations */
export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** Mutations */
export type MutationRevokeSessionArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Mutations */
export type MutationRunBasicAuthenticationArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


/** Mutations */
export type MutationSignUpArgs = {
  input: CreateUserInput;
  invitationSecret?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


/** Mutations */
export type MutationSubmitBmpResultArgs = {
  input: SubmitBmpResultInput;
};


/** Mutations */
export type MutationSubmitCardioRespResultArgs = {
  input: SubmitCardioRespResultInput;
};


/** Mutations */
export type MutationSubmitFinSwimResultArgs = {
  input: SubmitFinSwimResultInput;
};


/** Mutations */
export type MutationSubmitInbodyCompositionResultArgs = {
  input: SubmitInbodyCompositionResultInput;
};


/** Mutations */
export type MutationSubmitIndividualMotivationAssessmentResultArgs = {
  input: SubmitIndividualMotivationAssessmentResultInput;
};


/** Mutations */
export type MutationSubmitIpptResultArgs = {
  input: SubmitIpptResultInput;
};


/** Mutations */
export type MutationSubmitMl360AssessmentResultArgs = {
  input: SubmitMl360AssessmentResultInput;
};


/** Mutations */
export type MutationSubmitMarch20KmResultArgs = {
  input: SubmitMarch20KmResultInput;
};


/** Mutations */
export type MutationSubmitSartAssessmentResultArgs = {
  input: SubmitSartAssessmentResultInput;
};


/** Mutations */
export type MutationSubmitSelfDeterminationAssessmentResultArgs = {
  input: SubmitSelfDeterminationAssessmentResultInput;
};


/** Mutations */
export type MutationSubmitSocResultArgs = {
  input: SubmitSocResultInput;
};


/** Mutations */
export type MutationSubmitSpatialPlanningAssessmentResultArgs = {
  input: SubmitSpatialPlanningAssessmentResultInput;
};


/** Mutations */
export type MutationSubmitStrengthResultArgs = {
  input: SubmitStrengthResultInput;
};


/** Mutations */
export type MutationSubmitTeamResilienceAssessmentResultArgs = {
  input: SubmitTeamResilienceAssessmentResultInput;
};


/** Mutations */
export type MutationSubmitTrainersNotesResultArgs = {
  input: SubmitTrainersNotesResultInput;
};


/** Mutations */
export type MutationSubmitVisualReactionAssessmentResultArgs = {
  input: SubmitVisualReactionAssessmentResultInput;
};


/** Mutations */
export type MutationSubmitWeightResultArgs = {
  input: SubmitWeightResultInput;
};


/** Mutations */
export type MutationSwitchCompanyArgs = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
};


/** Mutations */
export type MutationUpdateAssessmentRunsArgs = {
  companyId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  input: UpdateAssessmentRunsInput;
};


/** Mutations */
export type MutationUpdateBmpResultArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateBmpResultInput;
};


/** Mutations */
export type MutationUpdateCardioRespResultArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateCardioRespResultInput;
};


/** Mutations */
export type MutationUpdateCompanyArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateCompanyInput;
};


/** Mutations */
export type MutationUpdateCourseInstanceArgs = {
  companyId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  input: UpdateCourseInstanceInput;
};


/** Mutations */
export type MutationUpdateCourseTemplateArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateCourseTemplateInput;
};


/** Mutations */
export type MutationUpdateFinSwimResultArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateFinSwimResultInput;
};


/** Mutations */
export type MutationUpdateGlossaryArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateGlossaryInput;
};


/** Mutations */
export type MutationUpdateGroupArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateGroupInput;
};


/** Mutations */
export type MutationUpdateInbodyCompositionResultArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateInbodyCompositionResultInput;
};


/** Mutations */
export type MutationUpdateIpptResultArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateIpptResultInput;
};


/** Mutations */
export type MutationUpdateMarch20KmResultArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateMarch20KmResultInput;
};


/** Mutations */
export type MutationUpdateModuleInstanceArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateModuleInstanceInput;
};


/** Mutations */
export type MutationUpdateProfileArgs = {
  name: Scalars['String']['input'];
};


/** Mutations */
export type MutationUpdateProgramArgs = {
  companyId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  input: UpdateProgramInput;
};


/** Mutations */
export type MutationUpdateSsoConfigurationArgs = {
  sso: SsoConfigurationInput;
};


/** Mutations */
export type MutationUpdateSocResultArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateSocResultInput;
};


/** Mutations */
export type MutationUpdateStrengthResultArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateStrengthResultInput;
};


/** Mutations */
export type MutationUpdateSubgroupArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateSubgroupInput;
};


/** Mutations */
export type MutationUpdateTrainersNotesResultArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateTrainersNotesResultInput;
};


/** Mutations */
export type MutationUpdateUserArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateUserInput;
};


/** Mutations */
export type MutationUpdateUserConsentArgs = {
  input: UpdateUserConsentInput;
};


/** Mutations */
export type MutationUpdateWeightResultArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateWeightResultInput;
};


/** Mutations */
export type MutationUploadDemoVideoArgs = {
  bumpVersion: Scalars['Boolean']['input'];
  file: Scalars['Upload']['input'];
  moduleInstanceId: Scalars['ObjectID']['input'];
  size: Scalars['Int']['input'];
};


/** Mutations */
export type MutationUploadImageArgs = {
  bumpVersion: Scalars['Boolean']['input'];
  file: Scalars['Upload']['input'];
  moduleInstanceId: Scalars['ObjectID']['input'];
  size: Scalars['Int']['input'];
};


/** Mutations */
export type MutationUploadRxnImageArgs = {
  bumpVersion: Scalars['Boolean']['input'];
  category: ImageCategory;
  file: Scalars['Upload']['input'];
  moduleInstanceId: Scalars['ObjectID']['input'];
  size: Scalars['Int']['input'];
};


/** Mutations */
export type MutationValidateImportAssessmentResultArgs = {
  assessmentRunId: Scalars['ObjectID']['input'];
  file: Scalars['Upload']['input'];
  moduleId: Scalars['ObjectID']['input'];
  resultType: AssessmentResultType;
};


/** Mutations */
export type MutationValidateImportPerformanceResultArgs = {
  file: Scalars['Upload']['input'];
  resultType: PerformanceResultType;
};


/** Mutations */
export type MutationValidateImportUsersArgs = {
  companyId: Scalars['ObjectID']['input'];
  file: Scalars['Upload']['input'];
};


/** Mutations */
export type MutationVerifyOtpArgs = {
  code: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
};

/** Input for creating company subscription details */
export type NewCompanySubscriptionInput = {
  /** Subscription duration in months */
  durationMonths: Scalars['Int']['input'];
  /** Free trial duration in days */
  freeTrialDays?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of user accounts allowed */
  maxUserLicenses: Scalars['Int']['input'];
  /** Number of days before expiry to send notification */
  renewalReminderDays?: InputMaybe<Scalars['Int']['input']>;
  /** Date when platform access begins */
  startDate: Scalars['DateTime']['input'];
};

/** OpenID Connect Configuration */
export type OidcConfiguration = {
  __typename: 'OIDCConfiguration';
  /** Callback URL */
  callback: Scalars['String']['output'];
  /** Client ID */
  clientId: Scalars['String']['output'];
  /** The OIDC issuer URL. */
  endpoint: Scalars['String']['output'];
  /** If true, the OIDC configuration is enforced over basic authentication. */
  enforced: Scalars['Boolean']['output'];
};

/** OpenID Connect Configuration */
export type OidcConfigurationInput = {
  /** Client ID */
  clientId: Scalars['String']['input'];
  /** Client Secret */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** The OIDC issuer URL. */
  endpoint: Scalars['String']['input'];
  /** If true, the OIDC configuration is enforced over basic authentication. */
  enforced: Scalars['Boolean']['input'];
};

/** Otp Authenticator */
export type OtpAuthenticator = {
  __typename: 'OtpAuthenticator';
  date: Scalars['DateTime']['output'];
};

/** Paginated Assessment Results */
export type PaginatedAssessmentResult = {
  __typename: 'PaginatedAssessmentResult';
  count: Scalars['Int']['output'];
  items: Array<AssessmentResult>;
  teamResilienceItems?: Maybe<Array<AssessmentResult>>;
};

/** Paginated AssessmentRun */
export type PaginatedAssessmentRun = {
  __typename: 'PaginatedAssessmentRun';
  count: Scalars['Int']['output'];
  items: Array<AssessmentRun>;
};

/** Paginated Company */
export type PaginatedCompany = {
  __typename: 'PaginatedCompany';
  count: Scalars['Int']['output'];
  items: Array<Company>;
};

/** Paginated Company Invitation */
export type PaginatedCompanyInvitation = {
  __typename: 'PaginatedCompanyInvitation';
  count: Scalars['Int']['output'];
  items: Array<CompanyInvitation>;
};

/** Paginated Course Instance */
export type PaginatedCourseInstance = {
  __typename: 'PaginatedCourseInstance';
  count: Scalars['Int']['output'];
  items: Array<CourseInstance>;
};

/** Paginated Course Template */
export type PaginatedCourseTemplate = {
  __typename: 'PaginatedCourseTemplate';
  count: Scalars['Int']['output'];
  items: Array<CourseTemplate>;
};

/** Paginated glossary term list. */
export type PaginatedGlossary = {
  __typename: 'PaginatedGlossary';
  count: Scalars['Int']['output'];
  items: Array<Glossary>;
};

/** Paginated Group */
export type PaginatedGroup = {
  __typename: 'PaginatedGroup';
  count: Scalars['Int']['output'];
  items: Array<Group>;
};

/** Represents a paginated list of ImportHistory. */
export type PaginatedImportHistory = {
  __typename: 'PaginatedImportHistory';
  count: Scalars['Int']['output'];
  items: Array<ImportHistory>;
};

/** Paginated Module Definitions */
export type PaginatedModuleDefinition = {
  __typename: 'PaginatedModuleDefinition';
  count: Scalars['Int']['output'];
  items: Array<ModuleDefinition>;
};

/** Paginated Module Instance */
export type PaginatedModuleInstance = {
  __typename: 'PaginatedModuleInstance';
  count: Scalars['Int']['output'];
  items: Array<ModuleInstance>;
};

/** Paginated Module Instance Launch Item */
export type PaginatedModuleInstanceLaunchItem = {
  __typename: 'PaginatedModuleInstanceLaunchItem';
  count: Scalars['Int']['output'];
  items: Array<ModuleInstanceLaunchItem>;
};

/** Paginated Performance Results */
export type PaginatedPerformanceResult = {
  __typename: 'PaginatedPerformanceResult';
  count: Scalars['Int']['output'];
  items: Array<PerformanceResult>;
};

/** Paginated Program */
export type PaginatedProgram = {
  __typename: 'PaginatedProgram';
  count: Scalars['Int']['output'];
  items: Array<Program>;
};

/** Paginated Subgroup */
export type PaginatedSubgroup = {
  __typename: 'PaginatedSubgroup';
  count: Scalars['Int']['output'];
  items: Array<Subgroup>;
};

/** Paginated trainee report rows. */
export type PaginatedTraineeReport = {
  __typename: 'PaginatedTraineeReport';
  count: Scalars['Int']['output'];
  items: Array<TraineeReportRow>;
};

/** Represents a paginated list of Users. */
export type PaginatedUser = {
  __typename: 'PaginatedUser';
  count: Scalars['Int']['output'];
  items: Array<User>;
};

/** Paginated User Session */
export type PaginatedUserSession = {
  __typename: 'PaginatedUserSession';
  count: Scalars['Int']['output'];
  items: Array<UserSession>;
};

/** Pagination */
export type Pagination = {
  /** Number of items to fetch from a list */
  limit: Scalars['Int']['input'];
  /** Offset to apply when fetching a list */
  offset: Scalars['Int']['input'];
};

/** Enum for the pass/fail result. */
export enum PassFailResult {
  Fail = 'Fail',
  Pass = 'Pass'
}

/** Represents a completed performance result linked to an assessment run. */
export type PerformanceResult = {
  __typename: 'PerformanceResult';
  assessmentRun?: Maybe<AssessmentRun>;
  assessmentRunId?: Maybe<Scalars['ObjectID']['output']>;
  company: Company;
  companyId: Scalars['ObjectID']['output'];
  completedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ObjectID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isTiedToAssessmentRun: Scalars['Boolean']['output'];
  result: PerformanceResultData;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['ObjectID']['output'];
  updatedByUser?: Maybe<User>;
  user?: Maybe<User>;
  userId: Scalars['ObjectID']['output'];
};

/** Union type for performance result data. */
export type PerformanceResultData = BmpResult | FinSwimResult | IpptResult | March20kmResult | SocResult | WeightResult;

/** Input type for filtering performance results. */
export type PerformanceResultFilterRule = {
  /** The assessment run IDs to filter results by. */
  assessmentRunIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** The company IDs to filter results by. */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** The group ids to filter results by. */
  groupIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** The performance result types to filter results by. */
  resultTypes?: InputMaybe<Array<PerformanceResultType>>;
  /** Search text to filter results by. */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** The subgroup ids to filter results by. */
  subgroupIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** The user IDs to filter results by. */
  userIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

/**
 * Fields available for sorting PerformanceResults.
 * Each field corresponds to a property in the PerformanceResult entity.
 */
export enum PerformanceResultSortingField {
  CompletionDate = 'CompletionDate',
  EndDate = 'EndDate',
  GroupName = 'GroupName',
  StartDate = 'StartDate',
  SubGroupName = 'SubGroupName',
  TraineeName = 'TraineeName'
}

/** Input type for sorting performance results. */
export type PerformanceResultSortingRule = {
  /** The field by which to sort the performance results. */
  field: PerformanceResultSortingField;
  /** The order in which to sort the performance results. */
  order: SortingOrder;
};

/** Enum for the type of performance result. */
export enum PerformanceResultType {
  Bmp = 'Bmp',
  FinSwim = 'FinSwim',
  Ippt = 'Ippt',
  March20km = 'March20km',
  Soc = 'Soc',
  Weight = 'Weight'
}

/** Defines common fields for all physical module instance configurations. */
export type PhysicalBaseConfiguration = {
  allowBulkImport: Scalars['Boolean']['output'];
  allowManualEntry: Scalars['Boolean']['output'];
  demoVideo?: Maybe<UploadedFile>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents a scheduled assessment run for a Program. */
export type Program = {
  __typename: 'Program';
  assessmentRunIds: Array<Scalars['ObjectID']['output']>;
  assessmentRuns: Array<AssessmentRun>;
  company: Company;
  companyId: Scalars['ObjectID']['output'];
  courseInstance: CourseInstance;
  courseInstanceId: Scalars['ObjectID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  occurrence: ProgramOccurrence;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

/** Input for filtering Programs. */
export type ProgramFilteringRule = {
  /** Filter by course instance ID. */
  courseInstanceId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Filter programs that have at least one completed assessment run. */
  includeAssessmentRunStatuses?: InputMaybe<Array<AssessmentRunStatus>>;
  /** Filter by Module Definition. */
  moduleDefinitionIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by program name (partial or exact match). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter across multiple relevant fields (name, description) using a single search term. */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Filter programs that have users from the specified user IDs. */
  userIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

/** Defines the type of program occurrence. */
export enum ProgramOccurrence {
  Custom = 'Custom',
  NotRepeating = 'NotRepeating'
}

/**
 * Fields available for sorting Programs.
 * Each field corresponds to a property in the Program entity.
 */
export enum ProgramSortingField {
  CourseInstanceName = 'CourseInstanceName',
  CreatedAt = 'CreatedAt',
  Description = 'Description',
  Name = 'Name'
}

/** Input type for sorting Program. */
export type ProgramSortingRule = {
  /** The field by which to sort the Program. */
  field: ProgramSortingField;
  /** The order in which to sort the Program. */
  order: SortingOrder;
};

/** The type of an option for a psychological question. */
export enum PsychologicalQuestionResponseType {
  Likert = 'Likert',
  MultipleChoice = 'MultipleChoice',
  Rating = 'Rating',
  ShortAnswer = 'ShortAnswer'
}

/** Queries */
export type Query = {
  __typename: 'Query';
  /** Get MSAL login URL */
  MSALUrl?: Maybe<Scalars['String']['output']>;
  /** Get OIDC login URL */
  OIDCUrl?: Maybe<Scalars['String']['output']>;
  /** Query to get a single assessment result by ID. */
  assessmentResult: AssessmentResult;
  /** Query to get multiple assessment results. */
  assessmentResults: PaginatedAssessmentResult;
  assessmentRun?: Maybe<AssessmentRun>;
  assessmentRuns: PaginatedAssessmentRun;
  /**
   * Fetches all active module definitions from the Admin DB.
   * Supports filtering by categories and sub-categories.
   */
  availableModules: PaginatedModuleDefinition;
  /** Fetch a list of companies with filtering, sorting, and pagination. */
  companies: PaginatedCompany;
  /** Fetch a single company by its ID. */
  company?: Maybe<Company>;
  /** Fetch a single course instance by ID. */
  courseInstance?: Maybe<CourseInstance>;
  /** Fetch course instances based on companyId. */
  courseInstances: PaginatedCourseInstance;
  /** Fetch a single course template by ID. */
  courseTemplate?: Maybe<CourseTemplate>;
  /** Fetch a single course template by name and version. */
  courseTemplateByNameAndVersion?: Maybe<CourseTemplate>;
  /** Fetch all versions of a course template by name. */
  courseTemplateVersions: Array<Scalars['Int']['output']>;
  /** Fetch course templates available to the current user's organization. */
  courseTemplates: PaginatedCourseTemplate;
  currentUser?: Maybe<User>;
  /**
   * Fetches the module definitions ENABLED for a specific company.
   * Optionally filters by module category.
   */
  enabledModulesForCompany: Array<ModuleDefinition>;
  /** Exports assessment results into a CSV file. */
  exportAssessmentResults: ExportAssessmentResultPayload;
  /** Exports performance results into a CSV file. */
  exportPerformanceResults: ExportPerformanceResultPayload;
  /** Generate authenticator qrcode */
  generateAuthenticatorQrCode: Scalars['String']['output'];
  /** Fetch a list of glossary items with optional filtering and pagination. */
  glossaries: PaginatedGlossary;
  /** Fetch a single glossary item by its ID. */
  glossary?: Maybe<Glossary>;
  /** Fetch a single group by its ID. */
  group?: Maybe<Group>;
  /** Fetch a list of groups with filtering, sorting, and pagination. */
  groups: PaginatedGroup;
  /** Fetches a list of importing row with optional filtering, sorting, and pagination. */
  importHistories: PaginatedImportHistory;
  /** Fetches a single importing row by its ID. */
  importHistory?: Maybe<ImportHistory>;
  incompleteModules: Array<AssessmentResult>;
  /** Fetch a list of invitations for a company. */
  invitations: PaginatedCompanyInvitation;
  /** Fetch a single invitee by their secret. */
  invitee?: Maybe<InviteeResponse>;
  /** Fetches a single module definition by ID. */
  moduleDefinition: ModuleDefinition;
  /** Fetches a single configured module instance by its ID. */
  moduleInstance?: Maybe<ModuleInstance>;
  /** Fetches a list of configured module instances for the user's organization. */
  moduleInstances: PaginatedModuleInstance;
  /** Fetches a list of module instances for a user to launch. */
  moduleInstancesForLaunch: PaginatedModuleInstanceLaunchItem;
  /** No-Operation Query */
  noop?: Maybe<Scalars['Boolean']['output']>;
  /** Query to get a single performance result by ID. */
  performanceResult: PerformanceResult;
  /** Query to get multiple performance results. */
  performanceResults: PaginatedPerformanceResult;
  /** Get a single Program by ID. */
  program?: Maybe<Program>;
  /** List Programs for a course instance, with pagination and filtering. */
  programs: PaginatedProgram;
  /** SSO Configuration */
  ssoConfiguration?: Maybe<SsoConfiguration>;
  /** Fetch a single subgroup by its ID. */
  subgroup?: Maybe<Subgroup>;
  /** Fetch a list of subgroups with filtering, sorting, and pagination. */
  subgroups: PaginatedSubgroup;
  /**
   * Get a download url for the latest version of a template by key.
   * Optionally restrict by company.
   */
  templateFile: TemplateDownloadPayload;
  traineeReports: PaginatedTraineeReport;
  /** Fetches a single user by their ID. */
  user?: Maybe<User>;
  userSessions: PaginatedUserSession;
  /** Fetches a list of users with optional filtering, sorting, and pagination. */
  users: PaginatedUser;
};


/** Queries */
export type QueryAssessmentResultArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryAssessmentResultsArgs = {
  filter?: InputMaybe<AssessmentResultFilterRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<AssessmentResultSortingRule>;
};


/** Queries */
export type QueryAssessmentRunArgs = {
  companyId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryAssessmentRunsArgs = {
  companyId: Scalars['ObjectID']['input'];
  filter?: InputMaybe<AssessmentRunFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<AssessmentRunSortingRule>;
};


/** Queries */
export type QueryAvailableModulesArgs = {
  filter?: InputMaybe<ModuleDefinitionFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ModuleDefinitionSortingRule>;
};


/** Queries */
export type QueryCompaniesArgs = {
  filter?: InputMaybe<CompanyFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<CompanySortingRule>;
};


/** Queries */
export type QueryCompanyArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryCourseInstanceArgs = {
  companyId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryCourseInstancesArgs = {
  companyId: Scalars['ObjectID']['input'];
  filter?: InputMaybe<CourseInstanceFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<CourseInstanceSortingRule>;
};


/** Queries */
export type QueryCourseTemplateArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryCourseTemplateByNameAndVersionArgs = {
  name: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


/** Queries */
export type QueryCourseTemplateVersionsArgs = {
  name: Scalars['String']['input'];
};


/** Queries */
export type QueryCourseTemplatesArgs = {
  filter?: InputMaybe<CourseTemplateFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<CourseTemplateSortingRule>;
};


/** Queries */
export type QueryEnabledModulesForCompanyArgs = {
  category?: InputMaybe<ModuleCategory>;
  companyId: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryExportAssessmentResultsArgs = {
  assessmentRunIds: Array<Scalars['ObjectID']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  isExcludeDescriptionRow?: InputMaybe<Scalars['Boolean']['input']>;
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  resultType: AssessmentResultType;
  searchText?: InputMaybe<Scalars['String']['input']>;
  subgroupIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};


/** Queries */
export type QueryExportPerformanceResultsArgs = {
  resultType: PerformanceResultType;
};


/** Queries */
export type QueryGenerateAuthenticatorQrCodeArgs = {
  authenticationToken?: InputMaybe<Scalars['String']['input']>;
};


/** Queries */
export type QueryGlossariesArgs = {
  filter?: InputMaybe<GlossaryFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<GlossarySortingRule>;
};


/** Queries */
export type QueryGlossaryArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryGroupArgs = {
  companyId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryGroupsArgs = {
  companyId: Scalars['ObjectID']['input'];
  filter?: InputMaybe<GroupFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<GroupSortingRule>;
};


/** Queries */
export type QueryImportHistoriesArgs = {
  companyId: Scalars['ObjectID']['input'];
  filter?: InputMaybe<ImportHistoryFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ImportHistorySortingRule>;
};


/** Queries */
export type QueryImportHistoryArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryIncompleteModulesArgs = {
  assessmentRunId: Scalars['ObjectID']['input'];
  programId: Scalars['ObjectID']['input'];
  userId: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryInvitationsArgs = {
  filter?: InputMaybe<CompanyInvitationFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<CompanyInvitationSortingRule>;
};


/** Queries */
export type QueryInviteeArgs = {
  secret: Scalars['String']['input'];
};


/** Queries */
export type QueryModuleDefinitionArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryModuleInstanceArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryModuleInstancesArgs = {
  filter?: InputMaybe<ModuleInstanceFilterRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ModuleInstanceSortingRule>;
};


/** Queries */
export type QueryModuleInstancesForLaunchArgs = {
  assessmentRunId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<Pagination>;
  subCategory?: InputMaybe<ModuleSubCategory>;
};


/** Queries */
export type QueryPerformanceResultArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryPerformanceResultsArgs = {
  filter?: InputMaybe<PerformanceResultFilterRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<PerformanceResultSortingRule>;
};


/** Queries */
export type QueryProgramArgs = {
  companyId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryProgramsArgs = {
  companyId: Scalars['ObjectID']['input'];
  filter?: InputMaybe<ProgramFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProgramSortingRule>;
};


/** Queries */
export type QuerySubgroupArgs = {
  companyId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
};


/** Queries */
export type QuerySubgroupsArgs = {
  companyId: Scalars['ObjectID']['input'];
  filter?: InputMaybe<SubgroupFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<SubgroupSortingRule>;
};


/** Queries */
export type QueryTemplateFileArgs = {
  filter: TemplateFilteringRule;
};


/** Queries */
export type QueryTraineeReportsArgs = {
  companyId: Scalars['ObjectID']['input'];
  filter?: InputMaybe<TraineeReportFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<TraineeReportSortingRule>;
};


/** Queries */
export type QueryUserArgs = {
  id: Scalars['ObjectID']['input'];
};


/** Queries */
export type QueryUserSessionsArgs = {
  id: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<Pagination>;
};


/** Queries */
export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<UserSortingRule>;
};

/** The type of a response to a rating scale question. */
export type RatingScaleResponse = {
  __typename: 'RatingScaleResponse';
  increment: Scalars['Int']['output'];
  maximumValue: Scalars['Int']['output'];
  minimumValue: Scalars['Int']['output'];
  responseType: PsychologicalQuestionResponseType;
  scaleLabels?: Maybe<Array<ScaleLabel>>;
};

/** Input type for a rating scale response. */
export type RatingScaleResponseInput = {
  increment: Scalars['Int']['input'];
  maximumValue: Scalars['Int']['input'];
  minimumValue: Scalars['Int']['input'];
  responseType: PsychologicalQuestionResponseType;
  scaleLabels?: InputMaybe<Array<ScaleLabelInput>>;
};

/** Represents a single Rating scale result. */
export type RatingScaleResult = {
  __typename: 'RatingScaleResult';
  maximumValue: Scalars['Int']['output'];
  minimumValue: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  type: ResponseResultType;
};

/** Input type for a Rating scale result. */
export type RatingScaleResultInput = {
  maximumValue: Scalars['Int']['input'];
  minimumValue: Scalars['Int']['input'];
  score: Scalars['Int']['input'];
};

/** A module definition for a reporting. */
export type ReportingModuleDefinition = BaseModuleDefinition & {
  __typename: 'ReportingModuleDefinition';
  category: ModuleCategory;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupingKey: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  identifier: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Request New Password Response
 *
 * The response may be of two types:
 * - RequestNewPasswordSuccessfulResponse : in case of success
 * - ErrorResponse : in case of error
 */
export type RequestNewPasswordResponse = ErrorResponse | RequestNewPasswordSuccessfulResponse;

/**
 * Request New Password Successful Response
 *
 * This is the response returned from a successful request new password request.
 */
export type RequestNewPasswordSuccessfulResponse = {
  __typename: 'RequestNewPasswordSuccessfulResponse';
  result: Scalars['Boolean']['output'];
};

/**
 * Reset Password Response
 *
 * The response may be of two types:
 * - ResetPasswordSuccessfulResponse : in case of success
 * - ErrorResponse : in case of error
 */
export type ResetPasswordResponse = ErrorResponse | ResetPasswordSuccessfulResponse;

/**
 * Reset Password Successful Response
 *
 * This is the response returned from a successful reset password request.
 */
export type ResetPasswordSuccessfulResponse = {
  __typename: 'ResetPasswordSuccessfulResponse';
  result: Scalars['Boolean']['output'];
};

/** Union type for response results. */
export type ResponseResult = LikertScaleResult | RatingScaleResult;

/** Input type for a response result. */
export type ResponseResultInput = {
  likertScaleResult?: InputMaybe<LikertScaleResultInput>;
  ratingScaleResult?: InputMaybe<RatingScaleResultInput>;
};

/** Enum for the type of response result. */
export enum ResponseResultType {
  Likert = 'Likert',
  Rating = 'Rating'
}

/** The type of a response to a question. */
export type ResponseType = LikertScaleResponse | RatingScaleResponse;

/**
 * A tagged union input type for response types.
 * Exactly one of the fields must be provided.
 */
export type ResponseTypeInput = {
  likertScale?: InputMaybe<LikertScaleResponseInput>;
  ratingScale?: InputMaybe<RatingScaleResponseInput>;
};

/** Enum for the source of the result. */
export enum ResultSource {
  FromManualEntry = 'FromManualEntry',
  FromRun = 'FromRun'
}

/** Rounds configuration for Visual Reaction assessment. */
export type RoundsConfiguration = {
  __typename: 'RoundsConfiguration';
  /** Number of images to memorize in this round. */
  numberOfImage: Scalars['Int']['output'];
};

/** Input type for rounds configuration. */
export type RoundsConfigurationInput = {
  /** Number of images to memorize in this round. */
  numberOfImage: Scalars['Int']['input'];
};

/** Specific configuration for a SART module instance. */
export type SartModuleInstanceConfiguration = BaseModuleInstanceConfiguration & {
  __typename: 'SARTModuleInstanceConfiguration';
  correctFeedbackDurationMs: Scalars['Int']['output'];
  demoVideo?: Maybe<UploadedFile>;
  digitDurationMs: Scalars['Int']['output'];
  displayDurationMs: Scalars['Int']['output'];
  incorrectFeedbackDurationMs: Scalars['Int']['output'];
  initialCrossDurationMs: Scalars['Int']['output'];
  instructionMobile?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  noiseLevel: Scalars['Float']['output'];
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
  triggerDigit: Array<Scalars['Int']['output']>;
};

/** Input type for SART module instance configuration. */
export type SartModuleInstanceConfigurationInput = {
  correctFeedbackDurationMs: Scalars['Int']['input'];
  digitDurationMs: Scalars['Int']['input'];
  displayDurationMs: Scalars['Int']['input'];
  incorrectFeedbackDurationMs: Scalars['Int']['input'];
  initialCrossDurationMs: Scalars['Int']['input'];
  instructionMobile?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  noiseLevel: Scalars['Float']['input'];
  numberOfPracticeQuestions?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions: Scalars['Int']['input'];
  reminders?: InputMaybe<Scalars['String']['input']>;
  showDemoVideo: Scalars['Boolean']['input'];
  triggerDigit: Array<Scalars['Int']['input']>;
};

/** SSO Configuration */
export type SsoConfiguration = MsalConfiguration | OidcConfiguration;

/** SSO Configuration */
export type SsoConfigurationInput = {
  msal?: InputMaybe<MsalConfigurationInput>;
  oidc?: InputMaybe<OidcConfigurationInput>;
};

/** Input representing the aggregated SART assessment result. */
export type SartAssessmentResultInput = {
  averageResponseTimeMs: Scalars['Float']['input'];
  correctHits: Scalars['Int']['input'];
  fastestResponseTimeMs: Scalars['Float']['input'];
  incorrectPresses: Scalars['Int']['input'];
  misses: Scalars['Int']['input'];
  trials: Array<SartTrialResultInput>;
};

/** Enum for SART error types. */
export enum SartErrorType {
  Incorrect = 'Incorrect',
  Missed = 'Missed'
}

/** Represents the aggregated result for SART. */
export type SartResult = {
  __typename: 'SartResult';
  averageResponseTimeMs: Scalars['Float']['output'];
  correctHits: Scalars['Int']['output'];
  fastestResponseTimeMs: Scalars['Float']['output'];
  incorrectPresses: Scalars['Int']['output'];
  misses: Scalars['Int']['output'];
  trials: Array<SartTrialResult>;
};

/** Represents a single trial result for SART. */
export type SartTrialResult = {
  __typename: 'SartTrialResult';
  errorType?: Maybe<SartErrorType>;
  index: Scalars['Int']['output'];
  isCorrect: Scalars['Boolean']['output'];
  isTriggerDigit: Scalars['Boolean']['output'];
  responseTimeMs: Scalars['Float']['output'];
  stimulusDigit: Scalars['Int']['output'];
};

/** Input representing a single trial result for SART. */
export type SartTrialResultInput = {
  errorType?: InputMaybe<SartErrorType>;
  index: Scalars['Int']['input'];
  isCorrect: Scalars['Boolean']['input'];
  isTriggerDigit: Scalars['Boolean']['input'];
  responseTimeMs: Scalars['Float']['input'];
  stimulusDigit: Scalars['Int']['input'];
};

/** The label for a rating scale response type. */
export type ScaleLabel = {
  __typename: 'ScaleLabel';
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

/** Input type for a scale label. */
export type ScaleLabelInput = {
  description: Scalars['String']['input'];
  label: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

/** The scoring for a Likert scale response type. */
export type Scoring = {
  __typename: 'Scoring';
  label: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

/** Input type for a scoring. */
export type ScoringInput = {
  label: Scalars['String']['input'];
  score: Scalars['Int']['input'];
};

/** Input type for a Self-Determination assessment result. */
export type SelfDeterminationAssessmentResultInput = {
  surveys: Array<SelfDeterminationSurveyResultInput>;
};

/** Represents the average score for a category. */
export type SelfDeterminationCategoryAverage = {
  __typename: 'SelfDeterminationCategoryAverage';
  averageScore: Scalars['Float']['output'];
  category: Scalars['String']['output'];
  maximumPossibleScore: Scalars['Int']['output'];
};

/** Specific configuration for an Self Determination module instance. */
export type SelfDeterminationModuleInstanceConfiguration = BaseModuleInstanceConfiguration & {
  __typename: 'SelfDeterminationModuleInstanceConfiguration';
  demoVideo?: Maybe<UploadedFile>;
  instructionMobile?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  questions: Array<SelfDeterminationQuestion>;
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for the configuration of a Self Determination module instance. */
export type SelfDeterminationModuleInstanceConfigurationInput = {
  instructionMobile?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfQuestions: Scalars['Int']['input'];
  questions: Array<SelfDeterminationQuestionInput>;
  reminders?: InputMaybe<Scalars['String']['input']>;
  showDemoVideo: Scalars['Boolean']['input'];
};

/** A question in the Self Determination module. */
export type SelfDeterminationQuestion = {
  __typename: 'SelfDeterminationQuestion';
  category: Scalars['String']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  scaleResponseType: ResponseType;
};

/** Input for a question in the Self Determination module. */
export type SelfDeterminationQuestionInput = {
  category: Scalars['String']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  scaleResponseType: ResponseTypeInput;
};

/** Aggregated Self-Determination assessment result. */
export type SelfDeterminationResult = {
  __typename: 'SelfDeterminationResult';
  categoryAverages: Array<SelfDeterminationCategoryAverage>;
  surveys: Array<SelfDeterminationSurveyResult>;
};

/** Represents a single Self-Determination survey result. */
export type SelfDeterminationSurveyResult = {
  __typename: 'SelfDeterminationSurveyResult';
  category: Scalars['String']['output'];
  question: Scalars['String']['output'];
  scoring: LikertScaleResult;
};

/** Input type for a Self-Determination survey result. */
export type SelfDeterminationSurveyResultInput = {
  category: Scalars['String']['input'];
  question: Scalars['String']['input'];
  scoring: LikertScaleResultInput;
};

/**
 * Sign Up Response
 *
 * The response may be of two types:
 * - SignUpSuccessResponse : in case of success
 * - ErrorResponse : in case of error
 */
export type SignUpResponse = ErrorResponse | SignUpSuccessResponse;

/**
 * Sign Up Success Response
 *
 * This is the response returned when a user successfully signs up.
 */
export type SignUpSuccessResponse = {
  __typename: 'SignUpSuccessResponse';
  result: Scalars['Boolean']['output'];
};

/** Specific configuration for an SOC module instance. */
export type SocConfiguration = BaseModuleInstanceConfiguration & PhysicalBaseConfiguration & {
  __typename: 'SocConfiguration';
  allowBulkImport: Scalars['Boolean']['output'];
  allowManualEntry: Scalars['Boolean']['output'];
  demoVideo?: Maybe<UploadedFile>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents the result for SOC. */
export type SocResult = {
  __typename: 'SocResult';
  result?: Maybe<PassFailResult>;
  timingSec?: Maybe<Scalars['Int']['output']>;
};

/**
 * Input representing the SOC assessment result details.
 * Fields are optional to allow partial submissions based on available measurements.
 */
export type SocResultInput = {
  /** Pass/Fail result for SOC. */
  result?: InputMaybe<PassFailResult>;
  /** SOC timing in seconds. */
  timingSec?: InputMaybe<Scalars['Int']['input']>;
};

/** Sorting Order */
export enum SortingOrder {
  /** Ascending order */
  Asc = 'Asc',
  /** Descending order */
  Desc = 'Desc'
}

/** Defines the source type for a course */
export enum SourceType {
  Custom = 'Custom',
  Template = 'Template'
}

/** Input representing the aggregated Spatial Planning assessment result. */
export type SpatialPlanningAssessmentResultInput = {
  accuracy: Scalars['Float']['input'];
  averageResponseTimeMs: Scalars['Float']['input'];
  correctAnswers: Scalars['Int']['input'];
  fastestResponseTimeMs: Scalars['Float']['input'];
  incorrectAnswers: Scalars['Int']['input'];
  trials: Array<SpatialPlanningTrialResultInput>;
};

/** Percentage distribution of questions by required move count. */
export type SpatialPlanningDistribution = {
  __typename: 'SpatialPlanningDistribution';
  moves3: Scalars['Float']['output'];
  moves4: Scalars['Float']['output'];
  moves5: Scalars['Float']['output'];
  moves6: Scalars['Float']['output'];
  moves7: Scalars['Float']['output'];
  moves8: Scalars['Float']['output'];
};

/** Input for percentage distribution of questions by move count. */
export type SpatialPlanningDistributionInput = {
  moves3: Scalars['Float']['input'];
  moves4: Scalars['Float']['input'];
  moves5: Scalars['Float']['input'];
  moves6: Scalars['Float']['input'];
  moves7: Scalars['Float']['input'];
  moves8: Scalars['Float']['input'];
};

/** Specific configuration for a Spatial Planning module instance. */
export type SpatialPlanningModuleInstanceConfiguration = BaseModuleInstanceConfiguration & {
  __typename: 'SpatialPlanningModuleInstanceConfiguration';
  assetSetKey?: Maybe<Scalars['String']['output']>;
  demoVideo?: Maybe<UploadedFile>;
  images?: Maybe<Array<UploadedFile>>;
  instructionMobile?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  practiceQuestionDistribution: SpatialPlanningDistribution;
  reminders?: Maybe<Scalars['String']['output']>;
  showAnswers: Scalars['Boolean']['output'];
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
  testQuestionDistribution: SpatialPlanningDistribution;
  timePerQuestionSeconds: Scalars['Int']['output'];
};

/** Input type for Spatial Planning module instance configuration. */
export type SpatialPlanningModuleInstanceConfigurationInput = {
  instructionMobile?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions: Scalars['Int']['input'];
  practiceQuestionDistribution: SpatialPlanningDistributionInput;
  reminders?: InputMaybe<Scalars['String']['input']>;
  showAnswers: Scalars['Boolean']['input'];
  showDemoVideo: Scalars['Boolean']['input'];
  testQuestionDistribution: SpatialPlanningDistributionInput;
  timePerQuestionSeconds: Scalars['Int']['input'];
};

/** Represents the aggregated result for Spatial Planning. */
export type SpatialPlanningResult = {
  __typename: 'SpatialPlanningResult';
  accuracy: Scalars['Float']['output'];
  averageResponseTimeMs: Scalars['Float']['output'];
  correctAnswers: Scalars['Int']['output'];
  fastestResponseTimeMs: Scalars['Float']['output'];
  incorrectAnswers: Scalars['Int']['output'];
  trials: Array<SpatialPlanningTrialResult>;
};

/** Represents a single trial result for Spatial Planning. */
export type SpatialPlanningTrialResult = {
  __typename: 'SpatialPlanningTrialResult';
  correctMoves: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  isCorrect: Scalars['Boolean']['output'];
  numberOfAttempts?: Maybe<Scalars['Int']['output']>;
  respondedMoves: Scalars['Int']['output'];
  responseTimeMs: Scalars['Float']['output'];
};

/** Input representing a single trial result for Spatial Planning. */
export type SpatialPlanningTrialResultInput = {
  correctMoves: Scalars['Int']['input'];
  index: Scalars['Int']['input'];
  isCorrect: Scalars['Boolean']['input'];
  numberOfAttempts?: InputMaybe<Scalars['Int']['input']>;
  respondedMoves: Scalars['Int']['input'];
  responseTimeMs: Scalars['Float']['input'];
};

/** Specific configuration for an Strength module instance. */
export type StrengthConfiguration = BaseModuleInstanceConfiguration & PhysicalBaseConfiguration & {
  __typename: 'StrengthConfiguration';
  allowBulkImport: Scalars['Boolean']['output'];
  allowManualEntry: Scalars['Boolean']['output'];
  demoVideo?: Maybe<UploadedFile>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents the result for Strength. */
export type StrengthResult = {
  __typename: 'StrengthResult';
  deadliftRepMaxKg?: Maybe<Scalars['Float']['output']>;
  maxPullUps?: Maybe<Scalars['Int']['output']>;
  sprintDragCarrySec?: Maybe<Scalars['Int']['output']>;
  squatRepMaxKg?: Maybe<Scalars['Float']['output']>;
};

/**
 * Input representing the Strength assessment result details.
 * Fields are optional to allow partial submissions based on available measurements.
 */
export type StrengthResultInput = {
  deadliftRepMaxKg?: InputMaybe<Scalars['Float']['input']>;
  maxPullUps?: InputMaybe<Scalars['Int']['input']>;
  sprintDragCarrySec?: InputMaybe<Scalars['Int']['input']>;
  squatRepMaxKg?: InputMaybe<Scalars['Float']['input']>;
};

/** Subgroup represents a subgroup within a group in the system. */
export type Subgroup = {
  __typename: 'Subgroup';
  /** Company this subgroup belongs to. */
  company: Company;
  /** Company identifier (ObjectId) this subgroup belongs to. */
  companyId: Scalars['ObjectID']['output'];
  /** Timestamp of creation. */
  createdAt: Scalars['DateTime']['output'];
  /** Creator of the subgroup. */
  createdBy?: Maybe<User>;
  /** Subgroup description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Group this subgroup belongs to. */
  group: Group;
  id: Scalars['ObjectID']['output'];
  /** Deletable flag. */
  isDeletable: Scalars['Boolean']['output'];
  /** Soft delete flag. */
  isDeleted: Scalars['Boolean']['output'];
  /** Member count of the subgroup. */
  memberCount: Scalars['Int']['output'];
  /** List of ObjectIDs representing members of the subgroup. */
  memberUserIds: Array<Scalars['ObjectID']['output']>;
  /** Members of the subgroup. */
  members?: Maybe<Array<User>>;
  /** Subgroup name. */
  name: Scalars['String']['output'];
  /** Group identifier (ObjectId) this subgroup belongs to. */
  parentGroupId: Scalars['ObjectID']['output'];
  /** Timestamp of last update. */
  updatedAt: Scalars['DateTime']['output'];
  /** Updater of the subgroup. */
  updatedBy?: Maybe<User>;
};

/** Input type for filtering Subgroups. */
export type SubgroupFilteringRule = {
  /** Filter by company description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Filter by company name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter across multiple relevant fields (name, description) using a single search term. */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

/** Fields available for sorting Subgroups. */
export enum SubgroupSortingField {
  Description = 'Description',
  Id = 'Id',
  MemberCount = 'MemberCount',
  Name = 'Name',
  UpdatedAt = 'UpdatedAt'
}

/** Input type for sorting Subgroups. */
export type SubgroupSortingRule = {
  /** The field by which to sort the subgroups. */
  field: SubgroupSortingField;
  /** The order in which to sort the subgroups. */
  order: SortingOrder;
};

/** Input type for submitting an BMP assessment result. */
export type SubmitBmpResultInput = {
  /** The assessment run instance identifier if tracked separately. */
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The company for which the assessment result is submitted. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt: Scalars['DateTime']['input'];
  /** The BMP result payload. */
  result: BmpResultInput;
  /** The user for whom the assessment result is submitted. */
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit a BMP assessment result. */
export type SubmitBmpResultPayload = ErrorResponse | SubmitBmpResultSuccessfulResponse;

/** Response payload after successfully submitting a BMP assessment result. */
export type SubmitBmpResultSuccessfulResponse = {
  __typename: 'SubmitBmpResultSuccessfulResponse';
  result?: Maybe<PerformanceResult>;
};

/** Input type for submitting a Cardio Respiratory assessment result. */
export type SubmitCardioRespResultInput = {
  /** The assessment run instance identifier if tracked separately. */
  assessmentRunId: Scalars['ObjectID']['input'];
  /** The company for which the assessment result is submitted. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt: Scalars['DateTime']['input'];
  /** The Cardio Respiratory result payload. */
  result: CardioRespResultInput;
  /** The user for whom the assessment result is submitted. */
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit a Cardio Respiratory assessment result. */
export type SubmitCardioRespResultPayload = ErrorResponse | SubmitCardioRespResultSuccessfulResponse;

/** Response payload after successfully submitting a Cardio Respiratory assessment result. */
export type SubmitCardioRespResultSuccessfulResponse = {
  __typename: 'SubmitCardioRespResultSuccessfulResponse';
  result?: Maybe<AssessmentResult>;
};

/** Input type for submitting a FinSwim assessment result. */
export type SubmitFinSwimResultInput = {
  /** The assessment run instance identifier if tracked separately. */
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The company for which the assessment result is submitted. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt: Scalars['DateTime']['input'];
  /** The FinSwim result payload. */
  result: FinSwimResultInput;
  /** The user for whom the assessment result is submitted. */
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit a FINSwim assessment result. */
export type SubmitFinSwimResultPayload = ErrorResponse | SubmitFinSwimResultSuccessfulResponse;

/** Response payload after successfully submitting a FINSwim assessment result. */
export type SubmitFinSwimResultSuccessfulResponse = {
  __typename: 'SubmitFinSwimResultSuccessfulResponse';
  result?: Maybe<PerformanceResult>;
};

/** Input type for submitting a Inbody Composition assessment result. */
export type SubmitInbodyCompositionResultInput = {
  /** The assessment run instance identifier if tracked separately. */
  assessmentRunId: Scalars['ObjectID']['input'];
  /** The company for which the assessment result is submitted. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt: Scalars['DateTime']['input'];
  /** The Inbody Composition result payload. */
  result: InbodyCompositionResultInput;
  /** The user for whom the assessment result is submitted. */
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit an Inbody Composition assessment result. */
export type SubmitInbodyCompositionResultPayload = ErrorResponse | SubmitInbodyCompositionResultSuccessfulResponse;

/** Response payload after successfully submitting an Inbody Composition assessment result. */
export type SubmitInbodyCompositionResultSuccessfulResponse = {
  __typename: 'SubmitInbodyCompositionResultSuccessfulResponse';
  result?: Maybe<AssessmentResult>;
};

/** Input type for submitting an Individual Motivation assessment result. */
export type SubmitIndividualMotivationAssessmentResultInput = {
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  companyId: Scalars['ObjectID']['input'];
  completedAt: Scalars['DateTime']['input'];
  courseInstanceId?: InputMaybe<Scalars['ObjectID']['input']>;
  isPreview: Scalars['Boolean']['input'];
  moduleInstanceId: Scalars['ObjectID']['input'];
  result: IndividualMotivationAssessmentResultInput;
  startedAt: Scalars['DateTime']['input'];
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit an Individual Motivation assessment result. */
export type SubmitIndividualMotivationAssessmentResultPayload = ErrorResponse | SubmitIndividualMotivationAssessmentResultSuccessfulResponse;

/** Response payload after successfully submitting an Individual Motivation assessment result. */
export type SubmitIndividualMotivationAssessmentResultSuccessfulResponse = {
  __typename: 'SubmitIndividualMotivationAssessmentResultSuccessfulResponse';
  result?: Maybe<AssessmentResult>;
};

/**
 * Input type for submitting an IPPT (Physical) assessment result.
 * Mirrors other submission inputs with standard context fields and a nested result payload.
 */
export type SubmitIpptResultInput = {
  /** The assessment run instance identifier if tracked separately. */
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The company for which the assessment result is submitted. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt: Scalars['DateTime']['input'];
  /** The IPPT result payload. */
  result: IpptResultInput;
  /** The user for whom the assessment result is submitted. */
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit an IPPT (Physical) assessment result. */
export type SubmitIpptResultPayload = ErrorResponse | SubmitIpptResultSuccessfulResponse;

/** Response payload after successfully submitting an IPPT assessment result. */
export type SubmitIpptResultSuccessfulResponse = {
  __typename: 'SubmitIpptResultSuccessfulResponse';
  result?: Maybe<PerformanceResult>;
};

/**
 * Input type for submitting a ML360 assessment result.
 * We expect the client to know which specific assessment is being submitted for,
 * so we include the relevant identifiers directly rather than an input union.
 */
export type SubmitMl360AssessmentResultInput = {
  /** Optional: The assessment run instance identifier if tracked separately. */
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The company for which the assessment result is submitted. */
  companyId: Scalars['ObjectID']['input'];
  /** Optional: The date and time when the assessment was completed. */
  completedAt: Scalars['DateTime']['input'];
  /** Optional: The course instance context if this result was part of a course run. */
  courseInstanceId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The mode is a preview of the assessment result submission. */
  isPreviewMode: Scalars['Boolean']['input'];
  /** The specific module instance the user completed (links runtime configuration). */
  moduleInstanceId: Scalars['ObjectID']['input'];
  /** The ML360 result payload. */
  result: Ml360AssessmentResultInput;
  /** The date and time when the assessment was started. */
  startedAt: Scalars['DateTime']['input'];
  /** The user for whom the assessment result is submitted. */
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit a ML360 assessment result. */
export type SubmitMl360AssessmentResultPayload = ErrorResponse | SubmitMl360AssessmentResultSuccessfulResponse;

/** Response payload after successfully submitting a ML360 assessment result. */
export type SubmitMl360AssessmentResultSuccessfulResponse = {
  __typename: 'SubmitML360AssessmentResultSuccessfulResponse';
  result?: Maybe<AssessmentResult>;
};

/** Input type for submitting a 20km Road March (Physical) assessment result. */
export type SubmitMarch20KmResultInput = {
  /** The assessment run instance identifier if tracked separately. */
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The company for which the assessment result is submitted. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt: Scalars['DateTime']['input'];
  /** The 20km Road March result payload. */
  result: March20KmResultInput;
  /** The user for whom the assessment result is submitted. */
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit a 20km Road March (Physical) assessment result. */
export type SubmitMarch20KmResultPayload = ErrorResponse | SubmitMarch20KmResultSuccessfulResponse;

/** Response payload after successfully submitting a 20km Road March assessment result. */
export type SubmitMarch20KmResultSuccessfulResponse = {
  __typename: 'SubmitMarch20KmResultSuccessfulResponse';
  result?: Maybe<PerformanceResult>;
};

/**
 * Input type for submitting a SART assessment result.
 * We expect the client to know which specific assessment is being submitted for,
 * so we include the relevant identifiers directly rather than an input union.
 */
export type SubmitSartAssessmentResultInput = {
  /** Optional: The assessment run instance identifier if tracked separately. */
  assessmentRunId: Scalars['ObjectID']['input'];
  /** The company for which the assessment result is submitted. */
  companyId: Scalars['ObjectID']['input'];
  /** Optional: The date and time when the assessment was completed. */
  completedAt: Scalars['DateTime']['input'];
  /** Optional: The course instance context if this result was part of a course run. */
  courseInstanceId: Scalars['ObjectID']['input'];
  /** The specific module instance the user completed (links runtime configuration). */
  moduleInstanceId: Scalars['ObjectID']['input'];
  /** The SART result payload. */
  result: SartAssessmentResultInput;
  /** The date and time when the assessment was started. */
  startedAt: Scalars['DateTime']['input'];
  /** The user for whom the assessment result is submitted. */
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit a SART assessment result. */
export type SubmitSartAssessmentResultPayload = ErrorResponse | SubmitSartAssessmentResultSuccessfulResponse;

/** Response payload after successfully submitting a SART assessment result. */
export type SubmitSartAssessmentResultSuccessfulResponse = {
  __typename: 'SubmitSartAssessmentResultSuccessfulResponse';
  result?: Maybe<AssessmentResult>;
};

/** Input type for submitting a Self-Determination assessment result. */
export type SubmitSelfDeterminationAssessmentResultInput = {
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  companyId: Scalars['ObjectID']['input'];
  completedAt: Scalars['DateTime']['input'];
  courseInstanceId?: InputMaybe<Scalars['ObjectID']['input']>;
  isPreview: Scalars['Boolean']['input'];
  moduleInstanceId: Scalars['ObjectID']['input'];
  result: SelfDeterminationAssessmentResultInput;
  startedAt: Scalars['DateTime']['input'];
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit a Self-Determination assessment result. */
export type SubmitSelfDeterminationAssessmentResultPayload = ErrorResponse | SubmitSelfDeterminationAssessmentResultSuccessfulResponse;

/** Response payload after successfully submitting a Self-Determination assessment result. */
export type SubmitSelfDeterminationAssessmentResultSuccessfulResponse = {
  __typename: 'SubmitSelfDeterminationAssessmentResultSuccessfulResponse';
  result?: Maybe<AssessmentResult>;
};

/** Input type for submitting a SOC (Physical) assessment result. */
export type SubmitSocResultInput = {
  /** The assessment run instance identifier if tracked separately. */
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The company for which the assessment result is submitted. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt: Scalars['DateTime']['input'];
  /** The SOC result payload. */
  result: SocResultInput;
  /** The user for whom the assessment result is submitted. */
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit a SOC (Physical) assessment result. */
export type SubmitSocResultPayload = ErrorResponse | SubmitSocResultSuccessfulResponse;

/** Response payload after successfully submitting a SOC assessment result. */
export type SubmitSocResultSuccessfulResponse = {
  __typename: 'SubmitSocResultSuccessfulResponse';
  result?: Maybe<PerformanceResult>;
};

/** Input type for submitting a Spatial Planning assessment result. */
export type SubmitSpatialPlanningAssessmentResultInput = {
  assessmentRunId: Scalars['ObjectID']['input'];
  companyId: Scalars['ObjectID']['input'];
  completedAt: Scalars['DateTime']['input'];
  courseInstanceId: Scalars['ObjectID']['input'];
  moduleInstanceId: Scalars['ObjectID']['input'];
  result: SpatialPlanningAssessmentResultInput;
  startedAt: Scalars['DateTime']['input'];
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit a Spatial Planning assessment result. */
export type SubmitSpatialPlanningAssessmentResultPayload = ErrorResponse | SubmitSpatialPlanningAssessmentResultSuccessfulResponse;

/** Response payload after successfully submitting a Spatial Planning assessment result. */
export type SubmitSpatialPlanningAssessmentResultSuccessfulResponse = {
  __typename: 'SubmitSpatialPlanningAssessmentResultSuccessfulResponse';
  result?: Maybe<AssessmentResult>;
};

/** Input type for submitting a Strength assessment result. */
export type SubmitStrengthResultInput = {
  /** The assessment run instance identifier if tracked separately. */
  assessmentRunId: Scalars['ObjectID']['input'];
  /** The company for which the assessment result is submitted. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt: Scalars['DateTime']['input'];
  /** The Strength result payload. */
  result: StrengthResultInput;
  /** The user for whom the assessment result is submitted. */
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit a Strength assessment result. */
export type SubmitStrengthResultPayload = ErrorResponse | SubmitStrengthResultSuccessfulResponse;

/** Response payload after successfully submitting a Strength assessment result. */
export type SubmitStrengthResultSuccessfulResponse = {
  __typename: 'SubmitStrengthResultSuccessfulResponse';
  result?: Maybe<AssessmentResult>;
};

/** Input type for submitting a Team Resilience assessment result. */
export type SubmitTeamResilienceAssessmentResultInput = {
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  companyId: Scalars['ObjectID']['input'];
  completedAt: Scalars['DateTime']['input'];
  courseInstanceId?: InputMaybe<Scalars['ObjectID']['input']>;
  isPreview: Scalars['Boolean']['input'];
  moduleInstanceId: Scalars['ObjectID']['input'];
  result: TeamResilienceAssessmentResultInput;
  startedAt: Scalars['DateTime']['input'];
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit a Team Resilience assessment result. */
export type SubmitTeamResilienceAssessmentResultPayload = ErrorResponse | SubmitTeamResilienceAssessmentResultSuccessfulResponse;

/** Response payload after successfully submitting a Team Resilience assessment result. */
export type SubmitTeamResilienceAssessmentResultSuccessfulResponse = {
  __typename: 'SubmitTeamResilienceAssessmentResultSuccessfulResponse';
  result?: Maybe<AssessmentResult>;
};

/** Input type for submitting a Trainers Notes assessment result. */
export type SubmitTrainersNotesResultInput = {
  assessmentRunId: Scalars['ObjectID']['input'];
  companyId: Scalars['ObjectID']['input'];
  /** Whether the result should be published immediately, else it will be created as a draft. */
  toBePublished?: InputMaybe<Scalars['Boolean']['input']>;
  trainersNotes?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit a Trainers Notes assessment result. */
export type SubmitTrainersNotesResultPayload = ErrorResponse | SubmitTrainersNotesResultSuccessfulResponse;

/** Response payload after successfully submitting a Trainers Notes assessment result. */
export type SubmitTrainersNotesResultSuccessfulResponse = {
  __typename: 'SubmitTrainersNotesResultSuccessfulResponse';
  result?: Maybe<AssessmentResult>;
};

/** Input type for submitting a Visual Reaction assessment result. */
export type SubmitVisualReactionAssessmentResultInput = {
  assessmentRunId: Scalars['ObjectID']['input'];
  companyId: Scalars['ObjectID']['input'];
  completedAt: Scalars['DateTime']['input'];
  courseInstanceId: Scalars['ObjectID']['input'];
  moduleInstanceId: Scalars['ObjectID']['input'];
  result: SubmitVisualReactionResultInput;
  startedAt: Scalars['DateTime']['input'];
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit a Visual Reaction assessment result. */
export type SubmitVisualReactionAssessmentResultPayload = ErrorResponse | SubmitVisualReactionAssessmentResultSuccessfulResponse;

/** Response payload after successfully submitting a Visual Reaction assessment result. */
export type SubmitVisualReactionAssessmentResultSuccessfulResponse = {
  __typename: 'SubmitVisualReactionAssessmentResultSuccessfulResponse';
  result?: Maybe<AssessmentResult>;
};

/** Input representing the aggregated Visual Reaction assessment result. */
export type SubmitVisualReactionResultInput = {
  accuracy: Scalars['Float']['input'];
  averageResponseTimeMs: Scalars['Float']['input'];
  correctAnswers: Scalars['Int']['input'];
  fastestResponseTimeMs: Scalars['Float']['input'];
  incorrectAnswers: Scalars['Int']['input'];
  rounds: Array<VisualReactionRoundResultInput>;
};

/** Input type for submitting a Weight (Physical) assessment result. */
export type SubmitWeightResultInput = {
  /** The assessment run instance identifier if tracked separately. */
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The company for which the assessment result is submitted. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt: Scalars['DateTime']['input'];
  /** The Weight result payload. */
  result: WeightResultInput;
  /** The user for whom the assessment result is submitted. */
  userId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to submit a Weight (Physical) assessment result. */
export type SubmitWeightResultPayload = ErrorResponse | SubmitWeightResultSuccessfulResponse;

/** Response payload after successfully submitting a Weight assessment result. */
export type SubmitWeightResultSuccessfulResponse = {
  __typename: 'SubmitWeightResultSuccessfulResponse';
  result?: Maybe<PerformanceResult>;
};

/** Subscriptions */
export type Subscription = {
  __typename: 'Subscription';
  eventFromConsoleSession: Broadcast;
  eventFromImportJob: ImportUsersProgressPayload;
  eventFromUserSession: Broadcast;
};


/** Subscriptions */
export type SubscriptionEventFromConsoleSessionArgs = {
  token: Scalars['String']['input'];
};


/** Subscriptions */
export type SubscriptionEventFromImportJobArgs = {
  companyId: Scalars['ObjectID']['input'];
  importHistoryIds: Array<Scalars['ObjectID']['input']>;
};


/** Subscriptions */
export type SubscriptionEventFromUserSessionArgs = {
  token: Scalars['String']['input'];
};

/** Represents a SuperAdmin user, not tied to a specific tenant. */
export type SuperAdminUser = BaseUser & {
  __typename: 'SuperAdminUser';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<BaseUser>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  has2FASetup: Scalars['Boolean']['output'];
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  isSuperAdmin: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  otpAuthenticator?: Maybe<OtpAuthenticator>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<BaseUser>;
};

/** Possible outcomes when attempting to switch company context */
export type SwitchCompanyResponse = ErrorResponse | SwitchCompanySuccessfulResponse;

/** Response payload after successfully switching company context */
export type SwitchCompanySuccessfulResponse = {
  __typename: 'SwitchCompanySuccessfulResponse';
  token: Scalars['String']['output'];
  user: User;
};

/** Input type for a Team Resilience assessment result. */
export type TeamResilienceAssessmentResultInput = {
  surveys: Array<TeamResilienceSurveyResultInput>;
};

/** Represents the average score for a category. */
export type TeamResilienceCategoryAverage = {
  __typename: 'TeamResilienceCategoryAverage';
  averageScore: Scalars['Float']['output'];
  category: Scalars['String']['output'];
  maximumPossibleScore: Scalars['Int']['output'];
};

/** Specific configuration for an Team Resilience module instance. */
export type TeamResilienceModuleInstanceConfiguration = BaseModuleInstanceConfiguration & {
  __typename: 'TeamResilienceModuleInstanceConfiguration';
  demoVideo?: Maybe<UploadedFile>;
  instructionMobile?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  questions: Array<TeamResilienceQuestion>;
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/** Input type for Team Resilience module instance configuration. */
export type TeamResilienceModuleInstanceConfigurationInput = {
  instructionMobile?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfQuestions: Scalars['Int']['input'];
  questions: Array<TeamResilienceQuestionInput>;
  reminders?: InputMaybe<Scalars['String']['input']>;
  showDemoVideo: Scalars['Boolean']['input'];
};

/** A question in the Team Resilience module. */
export type TeamResilienceQuestion = {
  __typename: 'TeamResilienceQuestion';
  category: Scalars['String']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  scaleResponseType: ResponseType;
  subCategory?: Maybe<Scalars['String']['output']>;
};

/** Input type for a Team Resilience question. */
export type TeamResilienceQuestionInput = {
  category: Scalars['String']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  scaleResponseType: ResponseTypeInput;
  subCategory?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the aggregated Team Resilience result. */
export type TeamResilienceResult = {
  __typename: 'TeamResilienceResult';
  categoryAverages: Array<TeamResilienceCategoryAverage>;
  subcategoryAverages: Array<TeamResilienceSubcategoryAverage>;
  surveys: Array<TeamResilienceSurveyResult>;
};

/** Represents the average score for a subcategory. */
export type TeamResilienceSubcategoryAverage = {
  __typename: 'TeamResilienceSubcategoryAverage';
  averageScore: Scalars['Float']['output'];
  category: Scalars['String']['output'];
  maximumPossibleScore: Scalars['Int']['output'];
  subcategory: Scalars['String']['output'];
};

/** Represents a single Team Resilience survey result. */
export type TeamResilienceSurveyResult = {
  __typename: 'TeamResilienceSurveyResult';
  category: Scalars['String']['output'];
  question: Scalars['String']['output'];
  scoring: ResponseResult;
  subcategory?: Maybe<Scalars['String']['output']>;
};

/** Input type for a Team Resilience survey result. */
export type TeamResilienceSurveyResultInput = {
  category: Scalars['String']['input'];
  question: Scalars['String']['input'];
  scoring: ResponseResultInput;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a downloadable template with versioning. */
export type Template = {
  __typename: 'Template';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  file: UploadedFile;
  id: Scalars['ObjectID']['output'];
  key: TemplateKey;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

/** Possible outcomes when attempting to download a template. */
export type TemplateDownloadPayload = ErrorResponse | TemplateDownloadSuccessfulResponse;

/** Response payload after successfully downloading a template. */
export type TemplateDownloadSuccessfulResponse = {
  __typename: 'TemplateDownloadSuccessfulResponse';
  result: Template;
};

/** Input type for filtering templates. */
export type TemplateFilteringRule = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  key: TemplateKey;
};

/** Identifies a specific template kind. Values map to backend keys. */
export enum TemplateKey {
  BmpImport = 'BmpImport',
  CardioRespImport = 'CardioRespImport',
  FinSwimImport = 'FinSwimImport',
  InbodyCompositionImport = 'InbodyCompositionImport',
  IpptImport = 'IpptImport',
  March20kmImport = 'March20kmImport',
  Ml360BuddyImport = 'Ml360BuddyImport',
  Ml360SelfImport = 'Ml360SelfImport',
  Ml360TrainerImport = 'Ml360TrainerImport',
  SartImport = 'SartImport',
  SelfDeterminationImport = 'SelfDeterminationImport',
  SocImport = 'SocImport',
  SpatialPlanningImport = 'SpatialPlanningImport',
  StrengthImport = 'StrengthImport',
  TeamResilienceImport = 'TeamResilienceImport',
  UserImport = 'UserImport',
  VisualRxnImport = 'VisualRxnImport',
  WeightImport = 'WeightImport'
}

/** Represents a regular user associated with a tenant (company). */
export type TenantUser = BaseUser & {
  __typename: 'TenantUser';
  allBuddies: Array<TenantUser>;
  allGroupIds: Array<Scalars['ObjectID']['output']>;
  allGroups: Array<Group>;
  allSubGroupIds: Array<Scalars['ObjectID']['output']>;
  allSubGroups: Array<Subgroup>;
  assignedGroups: Array<AssignedGroup>;
  company?: Maybe<Company>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<BaseUser>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  has2FASetup: Scalars['Boolean']['output'];
  hasConsentedForDataCollection: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  isSuperAdmin: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  otpAuthenticator?: Maybe<OtpAuthenticator>;
  role: UserRole;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<BaseUser>;
};

/** Filter for trainee reports listing. */
export type TraineeReportFilterInput = {
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  groupId?: InputMaybe<Scalars['ObjectID']['input']>;
  programId?: InputMaybe<Scalars['ObjectID']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  userIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

/** Row for Trainee Reports listing. Represents a specific trainee within an assessment run. */
export type TraineeReportRow = {
  __typename: 'TraineeReportRow';
  assessmentRunId: Scalars['ObjectID']['output'];
  assessmentRunName?: Maybe<Scalars['String']['output']>;
  canEdit: Scalars['Boolean']['output'];
  completionDate?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  groupId?: Maybe<Scalars['ObjectID']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['ObjectID']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  subGroupName?: Maybe<Scalars['String']['output']>;
  traineeName?: Maybe<Scalars['String']['output']>;
  trainersNotes?: Maybe<Scalars['String']['output']>;
  trainersNotesStatus?: Maybe<TrainersNotesStatus>;
  userId: Scalars['ObjectID']['output'];
};

/** Supported fields to sort trainee reports by. */
export enum TraineeReportSortingField {
  AssessmentRunName = 'AssessmentRunName',
  CompletionDate = 'CompletionDate',
  EndDate = 'EndDate',
  GroupName = 'GroupName',
  Programme = 'Programme',
  StartDate = 'StartDate',
  SubGroupName = 'SubGroupName',
  TraineeName = 'TraineeName',
  TrainersNotesStatus = 'TrainersNotesStatus'
}

/** Input type for sorting trainee reports. */
export type TraineeReportSortingRule = {
  field: TraineeReportSortingField;
  order: SortingOrder;
};

/** Represents the result for trainers notes. */
export type TrainersNotesResult = {
  __typename: 'TrainersNotesResult';
  status: TrainersNotesStatus;
  trainersNotes?: Maybe<Scalars['String']['output']>;
};

/** Enum for Trainer's Notes status. */
export enum TrainersNotesStatus {
  Draft = 'Draft',
  None = 'None',
  Published = 'Published'
}

/** A module definition for a training. */
export type TrainingModuleDefinition = BaseModuleDefinition & VariantSpecifics & {
  __typename: 'TrainingModuleDefinition';
  category: ModuleCategory;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupingKey: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  identifier: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  levelOrVariant?: Maybe<Scalars['String']['output']>;
  maxDurationMinutes?: Maybe<Scalars['Int']['output']>;
  minDurationMinutes?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  subCategory?: Maybe<ModuleSubCategory>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Transition effects for animations in Visual Reaction assessment. */
export enum TransitionEffect {
  FadeInOut = 'FadeInOut',
  SlideLeft = 'SlideLeft',
  SlideRight = 'SlideRight',
  ZoomIn = 'ZoomIn',
  ZoomOut = 'ZoomOut'
}

/** Input for updating an existing Assessment Runs. */
export type UpdateAssessmentRunsInput = {
  assessmentRuns: Array<AssessmentRunUpdateInput>;
  groupId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to update a Assessment Runs. */
export type UpdateAssessmentRunsPayload = ErrorResponse | UpdateAssessmentRunsSuccessfulResponse;

/** Response payload after successfully updating a Assessment Runs. */
export type UpdateAssessmentRunsSuccessfulResponse = {
  __typename: 'UpdateAssessmentRunsSuccessfulResponse';
  /** Indicates whether the update was successful. */
  result: Array<AssessmentRun>;
};

/**
 * Input type for updating an existing BMP assessment result.
 * User identity, module instance, course instance, and assessment run fields cannot be updated.
 */
export type UpdateBmpResultInput = {
  /** The assessment run ID. */
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The company for which the assessment result is updated. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The updated BMP metrics. */
  result?: InputMaybe<BmpResultInput>;
};

/** Possible outcomes when attempting to update a BMP assessment result. */
export type UpdateBmpResultPayload = ErrorResponse | UpdateBmpResultSuccessfulResponse;

/** Response payload after successfully updating a BMP assessment result. */
export type UpdateBmpResultSuccessfulResponse = {
  __typename: 'UpdateBmpResultSuccessfulResponse';
  result: PerformanceResult;
};

/**
 * Input type for updating an existing Cardio Respiratory assessment result.
 * User identity, module instance, course instance, and assessment run fields cannot be updated.
 */
export type UpdateCardioRespResultInput = {
  /** The company for which the assessment result is updated. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The updated Cardio Respiratory metrics. */
  result?: InputMaybe<CardioRespResultInput>;
};

/** Possible outcomes when attempting to update a Cardio Respiratory assessment result. */
export type UpdateCardioRespResultPayload = ErrorResponse | UpdateCardioRespResultSuccessfulResponse;

/** Response payload after successfully updating a Cardio Respiratory assessment result. */
export type UpdateCardioRespResultSuccessfulResponse = {
  __typename: 'UpdateCardioRespResultSuccessfulResponse';
  result: AssessmentResult;
};

/**
 * Input type for updating an existing Company.
 * Name cannot be updated.
 */
export type UpdateCompanyInput = {
  /** Contact information for the company. */
  contactInfo?: InputMaybe<CompanyContactInfoInput>;
  /** Optional: Enabled module identifiers for the company */
  enabledModules?: InputMaybe<Array<Scalars['String']['input']>>;
  /** General settings for the company. */
  generalSettings?: InputMaybe<CompanyGeneralSettingsInput>;
  /** Company status. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Role customization settings. This will replace the existing settings. */
  roleSettings?: InputMaybe<Array<CompanyRoleSettingInput>>;
  /** An optional short name or abbreviation. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Subscription details for the company. */
  subscription?: InputMaybe<UpdateCompanySubscriptionInput>;
};

/** Possible outcomes when attempting to update a Company. */
export type UpdateCompanyPayload = ErrorResponse | UpdateCompanySuccessfulResponse;

/** Input for updating company subscription details */
export type UpdateCompanySubscriptionInput = {
  /** Extension duration in days */
  extensionDays?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of user accounts allowed */
  maxUserLicenses?: InputMaybe<Scalars['Int']['input']>;
  /** Number of days before expiry to send notification */
  renewalReminderDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Response payload after successfully updating a Company. */
export type UpdateCompanySuccessfulResponse = {
  __typename: 'UpdateCompanySuccessfulResponse';
  /** The updated Company object. */
  result: Company;
};

/** Input type for updating a Course Instance. */
export type UpdateCourseInstanceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<DurationInput>;
  executionSequence?: InputMaybe<Array<ExecutionSequenceInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceTemplateId?: InputMaybe<Scalars['ObjectID']['input']>;
  sourceTemplateVersion?: InputMaybe<Scalars['Int']['input']>;
};

/** Possible outcomes when attempting to update a Course Instance. */
export type UpdateCourseInstancePayload = ErrorResponse | UpdateCourseInstanceSuccessfulResponse;

/** Response payload after successfully updating a Course Instance. */
export type UpdateCourseInstanceSuccessfulResponse = {
  __typename: 'UpdateCourseInstanceSuccessfulResponse';
  /** The updated Course Instance object. */
  result: CourseInstance;
};

/** Input type for updating a Course Template. */
export type UpdateCourseTemplateInput = {
  companyIds: Array<Scalars['ObjectID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<DurationInput>;
  executionSequence?: InputMaybe<Array<ExecutionSequenceInput>>;
  isPublic: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Possible outcomes when attempting to update a Course Template. */
export type UpdateCourseTemplatePayload = ErrorResponse | UpdateCourseTemplateSuccessfulResponse;

/** Response payload after successfully updating a Course Template. */
export type UpdateCourseTemplateSuccessfulResponse = {
  __typename: 'UpdateCourseTemplateSuccessfulResponse';
  /** The updated Course Template object. */
  result: CourseTemplate;
};

/**
 * Input type for updating an existing FinSwim assessment result.
 * User identity, module instance, course instance, and assessment run fields cannot be updated.
 */
export type UpdateFinSwimResultInput = {
  /** The assessment run ID. */
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The company for which the assessment result is updated. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The updated FinSwim metrics. */
  result?: InputMaybe<FinSwimResultInput>;
};

/** Possible outcomes when attempting to update a FINSwim assessment result. */
export type UpdateFinSwimResultPayload = ErrorResponse | UpdateFinSwimResultSuccessfulResponse;

/** Response payload after successfully updating a FINSwim assessment result. */
export type UpdateFinSwimResultSuccessfulResponse = {
  __typename: 'UpdateFinSwimResultSuccessfulResponse';
  result: PerformanceResult;
};

/**
 * Input for updating an existing glossary term.
 * All fields are optional; only provided fields will be updated.
 */
export type UpdateGlossaryInput = {
  definition?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

/** Possible outcomes when attempting to update a Glossary. */
export type UpdateGlossaryPayload = ErrorResponse | UpdateGlossarySuccessfulResponse;

/** Update Glossary Successful Response */
export type UpdateGlossarySuccessfulResponse = {
  __typename: 'UpdateGlossarySuccessfulResponse';
  /** The updated Glossary object. */
  result: Glossary;
};

/** Input for updating an existing Group. */
export type UpdateGroupInput = {
  /** Company identifier (ObjectId) this group belongs to. */
  companyId: Scalars['ObjectID']['input'];
  /** Description of the group. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** List of enrolled course IDs. */
  enrolledCourseIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** The name of the group. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Possible outcomes when attempting to update a Group. */
export type UpdateGroupPayload = ErrorResponse | UpdateGroupSuccessfulResponse;

/** Response payload after successfully updating a Group. */
export type UpdateGroupSuccessfulResponse = {
  __typename: 'UpdateGroupSuccessfulResponse';
  /** Indicates whether the update was successful. */
  result: Group;
};

/**
 * Input type for updating an existing Inbody Composition assessment result.
 * User identity, module instance, course instance, and assessment run fields cannot be updated.
 */
export type UpdateInbodyCompositionResultInput = {
  /** The company for which the assessment result is updated. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The updated Inbody Composition metrics. */
  result?: InputMaybe<InbodyCompositionResultInput>;
};

/** Possible outcomes when attempting to update an Inbody Composition assessment result. */
export type UpdateInbodyCompositionResultPayload = ErrorResponse | UpdateInbodyCompositionResultSuccessfulResponse;

/** Response payload after successfully updating an Inbody Composition assessment result. */
export type UpdateInbodyCompositionResultSuccessfulResponse = {
  __typename: 'UpdateInbodyCompositionResultSuccessfulResponse';
  result: AssessmentResult;
};

/**
 * Input type for updating an existing IPPT assessment result.
 * User identity, module instance, course instance, and assessment run fields cannot be updated.
 */
export type UpdateIpptResultInput = {
  /** The assessment run ID. */
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The company for which the assessment result is updated. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The updated IPPT metrics. */
  result?: InputMaybe<IpptResultInput>;
};

/** Possible outcomes when attempting to update an IPPT (Physical) assessment result. */
export type UpdateIpptResultPayload = ErrorResponse | UpdateIpptResultSuccessfulResponse;

/** Response payload after successfully updating an IPPT assessment result. */
export type UpdateIpptResultSuccessfulResponse = {
  __typename: 'UpdateIpptResultSuccessfulResponse';
  result: PerformanceResult;
};

/**
 * Input type for updating an existing 20km Road March assessment result.
 * User identity, module instance, course instance, and assessment run fields cannot be updated.
 */
export type UpdateMarch20KmResultInput = {
  /** The assessment run ID. */
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The company for which the assessment result is updated. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The updated 20km Road March metrics. */
  result?: InputMaybe<March20KmResultInput>;
};

/** Possible outcomes when attempting to update a 20km Road March assessment result. */
export type UpdateMarch20KmResultPayload = ErrorResponse | UpdateMarch20KmResultSuccessfulResponse;

/** Response payload after successfully updating a 20km Road March assessment result. */
export type UpdateMarch20KmResultSuccessfulResponse = {
  __typename: 'UpdateMarch20KmResultSuccessfulResponse';
  result: PerformanceResult;
};

/** Input type for updating a Module Instance. */
export type UpdateModuleInstanceInput = {
  configuration?: InputMaybe<ModuleInstanceConfigurationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Possible outcomes when attempting to update a Module Instance. */
export type UpdateModuleInstancePayload = ErrorResponse | UpdateModuleInstanceSuccessfulResponse;

/** Response payload after successfully updating a Module Instance. */
export type UpdateModuleInstanceSuccessfulResponse = {
  __typename: 'UpdateModuleInstanceSuccessfulResponse';
  result: ModuleInstance;
  /**
   * Indicates if the version was bumped due to the update.
   * This is only true if non-media configuration has changed.
   */
  versionBumped: Scalars['Boolean']['output'];
};

/**
 * Update Profile Response
 *
 * The response may be of two types:
 * - UpdateProfileSuccessfulResponse : in case of success
 * - ErrorResponse : in case of error
 */
export type UpdateProfileResponse = ErrorResponse | UpdateProfileSuccessfulResponse;

/**
 * Update Profile Successful Response
 *
 * This is the response returned from a successful update profile request.
 */
export type UpdateProfileSuccessfulResponse = {
  __typename: 'UpdateProfileSuccessfulResponse';
  result: Scalars['Boolean']['output'];
};

/** Input for updating a Program. */
export type UpdateProgramInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Possible outcomes when attempting to update a Program. */
export type UpdateProgramPayload = ErrorResponse | UpdateProgramSuccessfulResponse;

/** Response payload after successfully updating a Program. */
export type UpdateProgramSuccessfulResponse = {
  __typename: 'UpdateProgramSuccessfulResponse';
  /** Indicates whether the update was successful. */
  result: Program;
};

/**
 * Update SSO Response
 *
 * The response may be of two types:
 * - UpdateSSOSuccessfulResponse : in case of success
 * - ErrorResponse : in case of error
 */
export type UpdateSsoResponse = ErrorResponse | UpdateSsoSuccessfulResponse;

/**
 * Update Organization SSO Successful Response
 *
 * This is the response returned from a successful update organization base info request.
 */
export type UpdateSsoSuccessfulResponse = {
  __typename: 'UpdateSSOSuccessfulResponse';
  result?: Maybe<SsoConfiguration>;
};

/**
 * Input type for updating an existing SOC assessment result.
 * User identity, module instance, course instance, and assessment run fields cannot be updated.
 */
export type UpdateSocResultInput = {
  /** The assessment run ID. */
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The company for which the assessment result is updated. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The updated SOC metrics. */
  result?: InputMaybe<SocResultInput>;
};

/** Possible outcomes when attempting to update a SOC (Physical) assessment result. */
export type UpdateSocResultPayload = ErrorResponse | UpdateSocResultSuccessfulResponse;

/** Response payload after successfully updating a SOC assessment result. */
export type UpdateSocResultSuccessfulResponse = {
  __typename: 'UpdateSocResultSuccessfulResponse';
  result: PerformanceResult;
};

/**
 * Input type for updating an existing Strength assessment result.
 * User identity, module instance, course instance, and assessment run fields cannot be updated.
 */
export type UpdateStrengthResultInput = {
  /** The company for which the assessment result is updated. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The updated Strength metrics. */
  result?: InputMaybe<StrengthResultInput>;
};

/** Possible outcomes when attempting to update a Strength assessment result. */
export type UpdateStrengthResultPayload = ErrorResponse | UpdateStrengthResultSuccessfulResponse;

/** Response payload after successfully updating a Strength assessment result. */
export type UpdateStrengthResultSuccessfulResponse = {
  __typename: 'UpdateStrengthResultSuccessfulResponse';
  result: AssessmentResult;
};

/** Update a subgroup within a group. */
export type UpdateSubgroupInput = {
  /** Company identifier (ObjectId) this group belongs to. */
  companyId: Scalars['ObjectID']['input'];
  /** Description of the subgroup. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** List of member IDs (ObjectId) for the subgroup. */
  memberIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Name of the subgroup. */
  name: Scalars['String']['input'];
  /** Group identifier (ObjectId) this subgroup belongs to. */
  parentGroupId: Scalars['ObjectID']['input'];
};

/** Possible outcomes when attempting to update a Subgroup. */
export type UpdateSubgroupPayload = ErrorResponse | UpdateSubgroupSuccessfulResponse;

/** Response payload after successfully updating a Subgroup. */
export type UpdateSubgroupSuccessfulResponse = {
  __typename: 'UpdateSubgroupSuccessfulResponse';
  /** Indicates whether the update was successful. */
  result: Subgroup;
};

/** Input type for updating an existing Trainers Notes assessment result. */
export type UpdateTrainersNotesResultInput = {
  companyId: Scalars['ObjectID']['input'];
  /**
   * If true, publish the trainer's notes. When omitted or false, the
   * current status is preserved (no status change).
   */
  toBePublished?: InputMaybe<Scalars['Boolean']['input']>;
  trainersNotes?: InputMaybe<Scalars['String']['input']>;
};

/** Payload type for updating a Trainers Notes assessment result. */
export type UpdateTrainersNotesResultPayload = ErrorResponse | UpdateTrainersNotesResultSuccessfulResponse;

/** Response payload after successfully updating a Trainers Notes assessment result. */
export type UpdateTrainersNotesResultSuccessfulResponse = {
  __typename: 'UpdateTrainersNotesResultSuccessfulResponse';
  result?: Maybe<AssessmentResult>;
};

/** Input type for updating a user's consent status. */
export type UpdateUserConsentInput = {
  /** The new consent status. */
  hasConsentedForDataCollection: Scalars['Boolean']['input'];
  /** The ID of the user to update. */
  userId: Scalars['ObjectID']['input'];
};

/** Response union for updateUserConsent mutation. */
export type UpdateUserConsentResponse = ErrorResponse | UpdateUserConsentSuccessfulResponse;

/** Response payload after successfully updating a user's consent status. */
export type UpdateUserConsentSuccessfulResponse = {
  __typename: 'UpdateUserConsentSuccessfulResponse';
  result: User;
};

/** Input to update an existing User. */
export type UpdateUserInput = {
  assignedGroups?: InputMaybe<Array<InputMaybe<AssignedGroupInput>>>;
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  height?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
};

/** Possible outcomes when attempting to update a User. */
export type UpdateUserPayload = ErrorResponse | UpdateUserSuccessfulResponse;

/** Response payload after successfully updating a User. */
export type UpdateUserSuccessfulResponse = {
  __typename: 'UpdateUserSuccessfulResponse';
  result: User;
};

/**
 * Input type for updating an existing Weight assessment result.
 * User identity, module instance, course instance, and assessment run fields cannot be updated.
 */
export type UpdateWeightResultInput = {
  /** The assessment run ID. */
  assessmentRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The company for which the assessment result is updated. */
  companyId: Scalars['ObjectID']['input'];
  /** The date and time when the assessment was completed. */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The updated Weight metrics. */
  result?: InputMaybe<WeightResultInput>;
};

/** Possible outcomes when attempting to update a Weight (Physical) assessment result. */
export type UpdateWeightResultPayload = ErrorResponse | UpdateWeightResultSuccessfulResponse;

/** Response payload after successfully updating a Weight assessment result. */
export type UpdateWeightResultSuccessfulResponse = {
  __typename: 'UpdateWeightResultSuccessfulResponse';
  result: PerformanceResult;
};

/** Possible outcomes when attempting to upload a file. */
export type UploadFilePayload = ErrorResponse | UploadFileSuccessfulResponse;

/** Response payload after successfully uploading a file. */
export type UploadFileSuccessfulResponse = {
  __typename: 'UploadFileSuccessfulResponse';
  result: Scalars['Boolean']['output'];
};

/** Uploaded File */
export type UploadedFile = {
  __typename: 'UploadedFile';
  filename: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

/** User can be a SuperAdmin or a TenantUser. */
export type User = SuperAdminUser | TenantUser;

/** Input to filter a list of Users. */
export type UserFilteringRule = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  /** TODO: Add filtering by Group and SubGroup when defined */
  searchText?: InputMaybe<Scalars['String']['input']>;
  subGroupIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

/** Registration mode options for company users */
export enum UserRegistrationMode {
  Invite = 'Invite',
  SelfRegister = 'SelfRegister'
}

/** Defines the roles within the NeuroVibes platform, dictating user permissions and capabilities. */
export enum UserRole {
  CompanyAdmin = 'CompanyAdmin',
  CourseAdmin = 'CourseAdmin',
  Trainee = 'Trainee',
  Trainer = 'Trainer'
}

/**
 * User Session
 *
 * User Session is a session that a user has with the system.
 */
export type UserSession = {
  __typename: 'UserSession';
  id: Scalars['ObjectID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
  lastActivityAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

/**
 * UserSessionBroadcast is a type that represents a broadcast message that is sent to all subscribers
 * when a user session is revoked
 */
export type UserSessionBroadcast = {
  __typename: 'UserSessionBroadcast';
  revokeSession?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Fields by which a list of Users can be sorted.
 * TODO: Add sorting by Group and SubGroup when defined
 */
export enum UserSortingField {
  CompanyName = 'CompanyName',
  Email = 'Email',
  FirstName = 'FirstName',
  LastLogin = 'LastLogin',
  LastName = 'LastName',
  Role = 'Role'
}

/** Defines the sorting rule for a list of Users, specifying the field and direction. */
export type UserSortingRule = {
  field: UserSortingField;
  order: SortingOrder;
};

/** Represents the result of a validation assessment result import operation. */
export type ValidateImportAssessmentResult = {
  __typename: 'ValidateImportAssessmentResult';
  createNewCount?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<ValidateImportAssessmentResultRowError>>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
  updateCount?: Maybe<Scalars['Int']['output']>;
};

/** Possible outcomes when attempting to validate imported assessment results from a CSV file. */
export type ValidateImportAssessmentResultPayload = ErrorResponse | ValidateImportAssessmentResultSuccessfulResponse;

/** Validate Imported row error details. */
export type ValidateImportAssessmentResultRowError = {
  __typename: 'ValidateImportAssessmentResultRowError';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
};

/** Response payload after successfully validating imported assessment results from a CSV file. */
export type ValidateImportAssessmentResultSuccessfulResponse = {
  __typename: 'ValidateImportAssessmentResultSuccessfulResponse';
  result: ValidateImportAssessmentResult;
};

/** Represents the result of a validation performance result import operation. */
export type ValidateImportPerformanceResult = {
  __typename: 'ValidateImportPerformanceResult';
  createNewCount?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<ValidateImportPerformanceResultRowError>>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
  updateCount?: Maybe<Scalars['Int']['output']>;
};

/** Possible outcomes when attempting to validate imported performance results from a CSV file. */
export type ValidateImportPerformanceResultPayload = ErrorResponse | ValidateImportPerformanceResultSuccessfulResponse;

/** Validate Imported row error details. */
export type ValidateImportPerformanceResultRowError = {
  __typename: 'ValidateImportPerformanceResultRowError';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
};

/** Response payload after successfully validating imported performance results from a CSV file. */
export type ValidateImportPerformanceResultSuccessfulResponse = {
  __typename: 'ValidateImportPerformanceResultSuccessfulResponse';
  result: ValidateImportPerformanceResult;
};

/** Possible outcomes when attempting to validate imported users from a CSV file. */
export type ValidateImportUsersPayload = ErrorResponse | ValidateImportUsersSuccessfulResponse;

/** Response payload after successfully validating imported users from a CSV file. */
export type ValidateImportUsersSuccessfulResponse = {
  __typename: 'ValidateImportUsersSuccessfulResponse';
  result: ImportUsersResult;
};

/** Fields common to modules with variants, sub-categories, and tags. */
export type VariantSpecifics = {
  /** Optional level or variant (e.g., 'Beginner', 'Advanced'). */
  levelOrVariant?: Maybe<Scalars['String']['output']>;
  /** Optional sub-category (e.g., 'Cognitive', 'Psychological', etc.). */
  subCategory?: Maybe<ModuleSubCategory>;
  /** Optional tags for classification (e.g., ["memory", "reaction"]). */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * Verify Otp Response
 *
 * The response may be of two types:
 * - VerifyOtpSuccessfulResponse : in case of success
 * - ErrorResponse : in case of error
 */
export type VerifyOtpResponse = ErrorResponse | VerifyOtpSuccessfulResponse;

/**
 * Verify Otp Successful Response
 *
 * This is the response returned from a successful verify otp request.
 */
export type VerifyOtpSuccessfulResponse = {
  __typename: 'VerifyOtpSuccessfulResponse';
  result: Scalars['Boolean']['output'];
};

/** Enum for Visual Reaction error types. */
export enum VisualReactionErrorType {
  Incorrect = 'Incorrect',
  Missed = 'Missed'
}

/** Visual Reaction image configuration for Visual Reaction assessment. */
export type VisualReactionImage = {
  __typename: 'VisualReactionImage';
  /** Image category. */
  category: ImageCategory;
  /** Uploaded images for this category. */
  image: UploadedFile;
};

/** Specific configuration for a Visual Reaction (RXN) module instance. */
export type VisualReactionModuleInstanceConfiguration = BaseModuleInstanceConfiguration & {
  __typename: 'VisualReactionModuleInstanceConfiguration';
  animationDuration: Scalars['Int']['output'];
  assetSetKey?: Maybe<Scalars['String']['output']>;
  categories: Array<CategoryDetail>;
  categoryImages?: Maybe<Array<VisualReactionImage>>;
  demoVideo?: Maybe<UploadedFile>;
  displayTime: Scalars['Int']['output'];
  instructionMobile?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  intervalDuration: Scalars['Int']['output'];
  memorizationPhaseDisplayFormat: MemorizationPhaseDisplayFormat;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  noiseLevel: Scalars['Float']['output'];
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfPracticeRounds: Scalars['Int']['output'];
  numberOfQuestions: Scalars['Int']['output'];
  numberOfRounds: Scalars['Int']['output'];
  reminders?: Maybe<Scalars['String']['output']>;
  rounds: Array<RoundsConfiguration>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
  transitionEffects: TransitionEffect;
};

/** Input type for Visual Reaction module instance configuration. */
export type VisualReactionModuleInstanceConfigurationInput = {
  animationDuration: Scalars['Int']['input'];
  assetSetKey?: InputMaybe<Scalars['String']['input']>;
  categories: Array<CategoryDetailInput>;
  displayTime: Scalars['Int']['input'];
  instructionMobile?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  intervalDuration: Scalars['Int']['input'];
  memorizationPhaseDisplayFormat: MemorizationPhaseDisplayFormat;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  noiseLevel: Scalars['Float']['input'];
  numberOfPracticeQuestions: Scalars['Int']['input'];
  numberOfPracticeRounds: Scalars['Int']['input'];
  numberOfQuestions: Scalars['Int']['input'];
  numberOfRounds: Scalars['Int']['input'];
  reminders?: InputMaybe<Scalars['String']['input']>;
  rounds: Array<RoundsConfigurationInput>;
  showDemoVideo?: InputMaybe<Scalars['Boolean']['input']>;
  transitionEffects: TransitionEffect;
};

/** Representing the question result for Visual Reaction. */
export type VisualReactionQuestionResult = {
  __typename: 'VisualReactionQuestionResult';
  categories: Array<Scalars['String']['output']>;
  errorType?: Maybe<VisualReactionErrorType>;
  isCorrect: Scalars['Boolean']['output'];
  responseTimeMs: Scalars['Float']['output'];
};

/** Input representing the question result for Visual Reaction. */
export type VisualReactionQuestionResultInput = {
  categories: Array<Scalars['String']['input']>;
  errorType?: InputMaybe<VisualReactionErrorType>;
  isCorrect: Scalars['Boolean']['input'];
  responseTimeMs: Scalars['Float']['input'];
};

/** Representing test result for Visual Reaction. */
export type VisualReactionResult = {
  __typename: 'VisualReactionResult';
  accuracy: Scalars['Float']['output'];
  averageResponseTimeMs: Scalars['Float']['output'];
  correctAnswers: Scalars['Int']['output'];
  fastestResponseTimeMs: Scalars['Float']['output'];
  incorrectAnswers: Scalars['Int']['output'];
  rounds: Array<VisualReactionRoundResult>;
};

/** Representing the round result for Visual Reaction. */
export type VisualReactionRoundResult = {
  __typename: 'VisualReactionRoundResult';
  accuracyPerRound: Scalars['Float']['output'];
  averageResponseTimeMsPerRound: Scalars['Float']['output'];
  questions: Array<VisualReactionQuestionResult>;
};

/** Input representing the round result for Visual Reaction. */
export type VisualReactionRoundResultInput = {
  accuracyPerRound: Scalars['Float']['input'];
  averageResponseTimeMsPerRound: Scalars['Float']['input'];
  questions: Array<VisualReactionQuestionResultInput>;
};

/** Specific configuration for an Weight module instance. */
export type WeightConfiguration = BaseModuleInstanceConfiguration & PhysicalBaseConfiguration & {
  __typename: 'WeightConfiguration';
  allowBulkImport: Scalars['Boolean']['output'];
  allowManualEntry: Scalars['Boolean']['output'];
  demoVideo?: Maybe<UploadedFile>;
  instructions?: Maybe<Scalars['String']['output']>;
  moduleConfigurationType: ModuleInstanceConfigurationType;
  numberOfPracticeQuestions?: Maybe<Scalars['Int']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  reminders?: Maybe<Scalars['String']['output']>;
  showDemoVideo?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents the result for Weight. */
export type WeightResult = {
  __typename: 'WeightResult';
  weightKg?: Maybe<Scalars['Float']['output']>;
};

/**
 * Input representing the Weight assessment result details.
 * Fields are optional to allow partial submissions based on available measurements.
 */
export type WeightResultInput = {
  /** Body weight in kilograms. */
  weightKg?: InputMaybe<Scalars['Float']['input']>;
};
